/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @components/CookieBanner/Cookiebanner */ "./resources/scripts/components/CookieBanner/Cookiebanner.ts");
/* harmony import */ var _components_DataLayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/DataLayer */ "./resources/scripts/components/DataLayer/DataLayer.ts");
/* harmony import */ var _utils_ThemeScripts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/ThemeScripts */ "./resources/scripts/utils/ThemeScripts.ts");
/* harmony import */ var _components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* harmony import */ var _scripts_components_lowStock_lowStock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/lowStock/lowStock */ "./resources/scripts/components/lowStock/lowStock.ts");
/* harmony import */ var _scripts_components_ShopTheLook_ShopTheLook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scripts/components/ShopTheLook/ShopTheLook */ "./resources/scripts/components/ShopTheLook/ShopTheLook.ts");
/* harmony import */ var _scripts_components_RemoveAll_RemoveAll__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./scripts/components/RemoveAll/RemoveAll */ "./resources/scripts/components/RemoveAll/RemoveAll.ts");
/* harmony import */ var _scripts_components_PredictiveSearch_PredictiveSearch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./scripts/components/PredictiveSearch/PredictiveSearch */ "./resources/scripts/components/PredictiveSearch/PredictiveSearch.ts");
/* harmony import */ var _scripts_components_CustomFilters_CustomFilters__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./scripts/components/CustomFilters/CustomFilters */ "./resources/scripts/components/CustomFilters/CustomFilters.ts");
/* harmony import */ var _scripts_components_Wishlist_Wishlist__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./scripts/components/Wishlist/Wishlist */ "./resources/scripts/components/Wishlist/Wishlist.ts");
/* harmony import */ var _scripts_components_Wishlist_WishlistButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./scripts/components/Wishlist/WishlistButton */ "./resources/scripts/components/Wishlist/WishlistButton.ts");











// CookieBanner + DataLayer + GTM:
// 1. ThemeScripts loads GTM once CookieBanner has applied the gtag consent defaults.
// 2. DataLayer initialises on `edition:consent-default-set`.
// 3. CookieBanner is registered after both, so its connectedCallback fires the events above.
var scripts = new _utils_ThemeScripts__WEBPACK_IMPORTED_MODULE_0__.ThemeScripts();
var dataLayer = new _components_DataLayer__WEBPACK_IMPORTED_MODULE_1__.DataLayer();
scripts.load({
  id: "gtm",
  strategy: "on-default-consent-set",
  gtmConfig: {
    containerId: "GTM-KPMR3NV4",
    serverUrl: "https://cdn.pitaya.dk",
    scriptName: "8eweknwca.js"
  }
});
dataLayer.init();
// theme.js dispatches `drawerOpen.<id>` when a drawer opens
document.addEventListener("drawerOpen.CartDrawer", function () {
  var _window$editionDataLa;
  (_window$editionDataLa = window.editionDataLayer) === null || _window$editionDataLa === void 0 || _window$editionDataLa.trackCartView();
});
customElements.define("cookie-banner", _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define("geolocator-component", _components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define("low-stock", _scripts_components_lowStock_lowStock__WEBPACK_IMPORTED_MODULE_4__["default"]);
customElements.define("shop-the-look", _scripts_components_ShopTheLook_ShopTheLook__WEBPACK_IMPORTED_MODULE_5__["default"]);
customElements.define("remove-all", _scripts_components_RemoveAll_RemoveAll__WEBPACK_IMPORTED_MODULE_6__["default"]);
customElements.define("predictive-search-component", _scripts_components_PredictiveSearch_PredictiveSearch__WEBPACK_IMPORTED_MODULE_7__["default"]);
customElements.define("custom-filters", _scripts_components_CustomFilters_CustomFilters__WEBPACK_IMPORTED_MODULE_8__["default"]);
customElements.define("wishlist-button", _scripts_components_Wishlist_WishlistButton__WEBPACK_IMPORTED_MODULE_9__["default"]);
customElements.define("wishlist-component", _scripts_components_Wishlist_Wishlist__WEBPACK_IMPORTED_MODULE_10__["default"]);

/***/ }),

/***/ "./resources/scripts/components/CookieBanner/Cookiebanner.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/CookieBanner/Cookiebanner.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CookieBanner)
/* harmony export */ });
/* harmony import */ var _utils_Logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @utils/Logger */ "./resources/scripts/utils/Logger.ts");
/* harmony import */ var _utils_Storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/Storage */ "./resources/scripts/utils/Storage.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }


var CONSENT_STORAGE_KEY = "cookieSelections";
var CONSENT_DENIED_DEFAULTS = {
  personalization: false,
  marketing: false,
  analytics: false
};
var CONSENT_KEYS = ["personalization", "marketing", "analytics"];
/**
 * Cookie consent banner web component.
 *
 * Handles Consent Mode v2 (gtag default + update), Shopify Customer Privacy API
 * integration, and a consent-category checkbox UI with synced consent/details tabs.
 *
 * @example
 * ```html
 * <cookie-banner data-force-show="true"></cookie-banner>
 * ```
 *
 * @fires {CustomEvent} edition:consent-default-set - After gtag consent defaults are applied.
 * @fires {CustomEvent} edition:consent-updated     - After the user accepts, selects, or rejects.
 *
 * @see {@link showBanner} to open the banner programmatically.
 */
var CookieBanner = /*#__PURE__*/function (_HTMLElement) {
  function CookieBanner() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _classCallCheck(this, CookieBanner);
    _this = _callSuper(this, CookieBanner, [].concat(args));
    _defineProperty(_this, "consentApiReady", false);
    /** Sets gtag consent defaults, fires `edition:consent-default-set`, and optionally loads GTM. */
    _defineProperty(_this, "setupConsent", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _local$get, _window$gtag, _window, _window$gtag2, _window2, _window$gtag3, _window3;
      var selections;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.ensureGtag();
            selections = (_local$get = _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY)) !== null && _local$get !== void 0 ? _local$get : CONSENT_DENIED_DEFAULTS;
            (_window$gtag = (_window = window).gtag) === null || _window$gtag === void 0 || _window$gtag.call(_window, "consent", "default", {
              functionality_storage: "granted",
              analytics_storage: selections.analytics ? "granted" : "denied",
              personalization_storage: selections.personalization ? "granted" : "denied",
              ad_personalization: selections.personalization ? "granted" : "denied",
              ad_storage: selections.marketing ? "granted" : "denied",
              ad_user_data: selections.marketing ? "granted" : "denied",
              wait_for_update: 3000
            });
            (_window$gtag2 = (_window2 = window).gtag) === null || _window$gtag2 === void 0 || _window$gtag2.call(_window2, "set", "ads_data_redaction", !selections.marketing);
            (_window$gtag3 = (_window3 = window).gtag) === null || _window$gtag3 === void 0 || _window$gtag3.call(_window3, "set", "url_passthrough", true);
            window.dispatchEvent(new CustomEvent("edition:consent-default-set"));
            _context.n = 1;
            return _this.loadShopifyConsentApi();
          case 1:
            _context.n = 2;
            return _this.restoreExistingConsent();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    /**
     * Visitors who chose before this banner shipped have no selections in our storage format:
     * the old banner stored raw JSON under the same key, and Shopify keeps its own record.
     * Re-apply that earlier choice instead of leaving consent at the denied defaults.
     */
    _defineProperty(_this, "restoreExistingConsent", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _window$Shopify;
      var previous, _localStorage$getItem, raw, _yield$window$Shopify, preferences, analytics, marketing, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!_utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            previous = null;
            try {
              raw = JSON.parse((_localStorage$getItem = localStorage.getItem(CONSENT_STORAGE_KEY)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : "null");
              if (raw && typeof raw.analytics === "boolean") {
                previous = {
                  personalization: !!raw.personalization,
                  marketing: !!raw.marketing,
                  analytics: raw.analytics
                };
              }
            } catch (_unused) {
              // not the old format
            }
            if (!(!previous && _this.consentApiReady && (_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.customerPrivacy) !== null && _window$Shopify !== void 0 && _window$Shopify.currentVisitorConsent)) {
              _context2.n = 5;
              break;
            }
            _context2.p = 2;
            _context2.n = 3;
            return window.Shopify.customerPrivacy.currentVisitorConsent();
          case 3:
            _yield$window$Shopify = _context2.v;
            preferences = _yield$window$Shopify.preferences;
            analytics = _yield$window$Shopify.analytics;
            marketing = _yield$window$Shopify.marketing;
            if ([preferences, analytics, marketing].some(function (v) {
              return (v !== null && v !== void 0 ? v : "") !== "";
            })) {
              previous = {
                personalization: preferences === "yes",
                marketing: marketing === "yes",
                analytics: analytics === "yes"
              };
            }
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t = _context2.v;
            _utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].error("Could not read Shopify visitor consent", _t);
          case 5:
            if (previous) {
              _context2.n = 6;
              break;
            }
            return _context2.a(2);
          case 6:
            CONSENT_KEYS.forEach(function (key) {
              return _this.setConsentGroup({
                key: key,
                checked: previous[key]
              });
            });
            _this.applyConsent({
              consent: {
                preferences: previous.personalization ? "yes" : "no",
                marketing: previous.marketing ? "yes" : "no",
                analytics: previous.analytics ? "yes" : "no"
              },
              hide: false
            });
          case 7:
            return _context2.a(2);
        }
      }, _callee2, null, [[2, 4]]);
    })));
    _defineProperty(_this, "addEventListeners", function () {
      var _this$querySelector, _this$querySelector2, _this$querySelector3, _this$querySelector4, _this$querySelector5, _document$getElementB;
      (_this$querySelector = _this.querySelector("#tab-consent")) === null || _this$querySelector === void 0 || _this$querySelector.addEventListener("click", function () {
        return _this.activateTab("consent");
      });
      (_this$querySelector2 = _this.querySelector("#tab-details")) === null || _this$querySelector2 === void 0 || _this$querySelector2.addEventListener("click", function () {
        return _this.activateTab("details");
      });
      (_this$querySelector3 = _this.querySelector(".allow-all-btn")) === null || _this$querySelector3 === void 0 || _this$querySelector3.addEventListener("click", _this.handleAllowAll);
      (_this$querySelector4 = _this.querySelector(".allow-selected-btn")) === null || _this$querySelector4 === void 0 || _this$querySelector4.addEventListener("click", _this.handleAllowSelected);
      (_this$querySelector5 = _this.querySelector('[data-action="reject"]')) === null || _this$querySelector5 === void 0 || _this$querySelector5.addEventListener("click", _this.handleRejectAll);
      (_document$getElementB = document.getElementById("manage-cookie-consent")) === null || _document$getElementB === void 0 || _document$getElementB.addEventListener("click", function (event) {
        event.preventDefault();
        _this.showBanner();
      });
    });
    _defineProperty(_this, "activateTab", function (tab) {
      ["consent", "details"].forEach(function (id) {
        var _this$querySelector6, _this$querySelector7, _this$querySelector8;
        (_this$querySelector6 = _this.querySelector("#tab-".concat(id))) === null || _this$querySelector6 === void 0 || _this$querySelector6.classList.toggle("active", id === tab);
        (_this$querySelector7 = _this.querySelector("#panel-".concat(id))) === null || _this$querySelector7 === void 0 || _this$querySelector7.classList.toggle("active", id === tab);
        (_this$querySelector8 = _this.querySelector("#panel-".concat(id))) === null || _this$querySelector8 === void 0 || _this$querySelector8.classList.toggle("tw:hidden!", id !== tab);
      });
    });
    /**
     * Returns true if the banner should be shown.
     * Prefers localStorage over the Shopify API — if the user has a stored selection we trust it
     * and skip the async API call entirely.
     */
    _defineProperty(_this, "shouldShowBanner", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _window$Shopify2;
      var _yield$window$Shopify2, preferences, analytics, marketing, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!_utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2, false);
          case 1:
            if (!(!_this.consentApiReady || !((_window$Shopify2 = window.Shopify) !== null && _window$Shopify2 !== void 0 && (_window$Shopify2 = _window$Shopify2.customerPrivacy) !== null && _window$Shopify2 !== void 0 && _window$Shopify2.currentVisitorConsent))) {
              _context3.n = 2;
              break;
            }
            return _context3.a(2, true);
          case 2:
            _context3.p = 2;
            _context3.n = 3;
            return window.Shopify.customerPrivacy.currentVisitorConsent();
          case 3:
            _yield$window$Shopify2 = _context3.v;
            preferences = _yield$window$Shopify2.preferences;
            analytics = _yield$window$Shopify2.analytics;
            marketing = _yield$window$Shopify2.marketing;
            return _context3.a(2, [preferences, analytics, marketing].every(function (v) {
              return (v !== null && v !== void 0 ? v : "") === "";
            }));
          case 4:
            _context3.p = 4;
            _t2 = _context3.v;
            return _context3.a(2, true);
        }
      }, _callee3, null, [[2, 4]]);
    })));
    _defineProperty(_this, "loadShopifyConsentApi", function () {
      var _window$Shopify3;
      if (!((_window$Shopify3 = window.Shopify) !== null && _window$Shopify3 !== void 0 && _window$Shopify3.loadFeatures)) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        try {
          window.Shopify.loadFeatures([{
            name: "consent-tracking-api",
            version: "0.1"
          }], function (error) {
            if (error) {
              _utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].error("Shopify consent-tracking-api failed to load", error);
              resolve();
              return;
            }
            _this.consentApiReady = true;
            resolve();
            document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
              var _window$Shopify4, _window$Shopify4$curr, v, _t3;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.p = _context4.n) {
                  case 0:
                    _context4.p = 0;
                    _context4.n = 1;
                    return (_window$Shopify4 = window.Shopify) === null || _window$Shopify4 === void 0 || (_window$Shopify4 = _window$Shopify4.customerPrivacy) === null || _window$Shopify4 === void 0 || (_window$Shopify4$curr = _window$Shopify4.currentVisitorConsent) === null || _window$Shopify4$curr === void 0 ? void 0 : _window$Shopify4$curr.call(_window$Shopify4);
                  case 1:
                    v = _context4.v;
                    if (v) {
                      _context4.n = 2;
                      break;
                    }
                    return _context4.a(2);
                  case 2:
                    _this.setConsentGroup({
                      key: "personalization",
                      checked: v.preferences === "yes"
                    });
                    _this.setConsentGroup({
                      key: "marketing",
                      checked: v.marketing === "yes"
                    });
                    _this.setConsentGroup({
                      key: "analytics",
                      checked: v.analytics === "yes"
                    });
                    _this.saveSelections();
                    _context4.n = 4;
                    break;
                  case 3:
                    _context4.p = 3;
                    _t3 = _context4.v;
                    _utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].error("visitorConsentCollected handler error", _t3);
                  case 4:
                    return _context4.a(2);
                }
              }, _callee4, null, [[0, 3]]);
            })));
          });
        } catch (e) {
          _utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].error("Shopify loadFeatures threw", e);
          resolve();
        }
      });
    });
    /** Updates gtag consent, persists to localStorage, and fires `edition:consent-updated`. */
    _defineProperty(_this, "applyConsent", function (_ref5) {
      var _window$gtag4, _window4, _window$gtag5, _window5, _window$Shopify5, _window$Shopify5$setT;
      var consent = _ref5.consent,
        hide = _ref5.hide;
      var consentSettings = {
        functionality_storage: "granted",
        analytics_storage: consent.analytics === "yes" ? "granted" : "denied",
        personalization_storage: consent.preferences === "yes" ? "granted" : "denied",
        ad_personalization: consent.preferences === "yes" ? "granted" : "denied",
        ad_storage: consent.marketing === "yes" ? "granted" : "denied",
        ad_user_data: consent.marketing === "yes" ? "granted" : "denied"
      };
      (_window$gtag4 = (_window4 = window).gtag) === null || _window$gtag4 === void 0 || _window$gtag4.call(_window4, "consent", "update", consentSettings);
      // Legacy key written by the old Consent component. Store scripts in theme settings
      // (e.g. the consent-gated Clarity snippet on NO/DE/COM) still read it.
      try {
        localStorage.setItem("consentSettings", JSON.stringify(consentSettings));
      } catch (_unused3) {
        // storage unavailable
      }
      (_window$gtag5 = (_window5 = window).gtag) === null || _window$gtag5 === void 0 || _window$gtag5.call(_window5, "set", "ads_data_redaction", consent.marketing !== "yes");
      _this.saveSelections();
      window.dispatchEvent(new CustomEvent("edition:consent-updated"));
      (_window$Shopify5 = window.Shopify) === null || _window$Shopify5 === void 0 || (_window$Shopify5 = _window$Shopify5.customerPrivacy) === null || _window$Shopify5 === void 0 || (_window$Shopify5$setT = _window$Shopify5.setTrackingConsent) === null || _window$Shopify5$setT === void 0 || _window$Shopify5$setT.call(_window$Shopify5, {
        analytics: consent.analytics === "yes",
        marketing: consent.marketing === "yes",
        preferences: consent.preferences === "yes"
      });
      if (hide) {
        _this.hideBanner();
      }
    });
    _defineProperty(_this, "handleAllowAll", function () {
      _this.querySelectorAll("input.ed-checkbox[data-consent]").forEach(function (cb) {
        if (!cb.disabled) {
          cb.checked = true;
        }
      });
      _this.applyConsent({
        consent: {
          preferences: "yes",
          marketing: "yes",
          analytics: "yes"
        },
        hide: true
      });
    });
    _defineProperty(_this, "handleAllowSelected", function () {
      var _this$getSelections = _this.getSelections(),
        personalization = _this$getSelections.personalization,
        marketing = _this$getSelections.marketing,
        analytics = _this$getSelections.analytics;
      _this.applyConsent({
        consent: {
          preferences: personalization ? "yes" : "no",
          marketing: marketing ? "yes" : "no",
          analytics: analytics ? "yes" : "no"
        },
        hide: true
      });
    });
    _defineProperty(_this, "handleRejectAll", function () {
      _this.applyConsent({
        consent: {
          preferences: "no",
          marketing: "no",
          analytics: "no"
        },
        hide: true
      });
    });
    /** Keeps the consent/details tab panels in sync — the same consent key can appear in both tabs. */
    _defineProperty(_this, "syncCheckboxGroups", function () {
      var checkboxes = Array.from(_this.querySelectorAll("input.ed-checkbox[data-consent]"));
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener("change", function (_ref6) {
          var currentTarget = _ref6.currentTarget;
          var source = currentTarget;
          checkboxes.forEach(function (other) {
            if (other !== source && other.dataset.consent === source.dataset.consent && !other.disabled) {
              other.checked = source.checked;
            }
          });
        });
      });
      var grouped = checkboxes.reduce(function (acc, cb) {
        var _acc$key;
        var key = cb.dataset.consent;
        ((_acc$key = acc[key]) !== null && _acc$key !== void 0 ? _acc$key : acc[key] = []).push(cb);
        return acc;
      }, {});
      Object.values(grouped).forEach(function (_ref7) {
        var _ref8 = _toArray(_ref7),
          source = _ref8[0],
          rest = _arrayLikeToArray(_ref8).slice(1);
        rest.forEach(function (cb) {
          if (!cb.disabled) {
            cb.checked = source.checked;
          }
        });
      });
    });
    _defineProperty(_this, "setConsentGroup", function (_ref9) {
      var key = _ref9.key,
        checked = _ref9.checked;
      _this.querySelectorAll("input.ed-checkbox[data-consent=\"".concat(key, "\"]")).forEach(function (cb) {
        if (!cb.disabled) {
          cb.checked = checked;
        }
      });
    });
    _defineProperty(_this, "saveSelections", function () {
      _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.set(CONSENT_STORAGE_KEY, _this.getSelections());
    });
    _defineProperty(_this, "getSelections", function () {
      return CONSENT_KEYS.reduce(function (acc, key) {
        var _this$querySelector9;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, !!((_this$querySelector9 = _this.querySelector("input.ed-checkbox[data-consent=\"".concat(key, "\"]"))) !== null && _this$querySelector9 !== void 0 && _this$querySelector9.checked)));
      }, {
        personalization: false,
        marketing: false,
        analytics: false
      });
    });
    /**
     * Opens the banner. Applies any previously saved selections to the checkboxes first —
     * if nothing is stored, the HTML defaults remain as-is.
     * Can be triggered externally via `#manage-cookie-consent`.
     */
    _defineProperty(_this, "showBanner", function () {
      var saved = _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY);
      if (saved) {
        CONSENT_KEYS.forEach(function (key) {
          return _this.setConsentGroup({
            key: key,
            checked: saved[key]
          });
        });
      }
      _this.overlay.removeAttribute("hidden");
      _this.overlay.classList.remove("tw:hidden!");
    });
    _defineProperty(_this, "hideBanner", function () {
      _this.overlay.classList.add("tw:hidden!");
    });
    /** Creates a `window.gtag` shim that queues calls into `dataLayer` if the real gtag hasn't loaded yet. */
    // eslint-disable-next-line class-methods-use-this
    _defineProperty(_this, "ensureGtag", function () {
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) {
        // function keyword is intentional — arrow functions have no `arguments` object,
        // but GTM's consent processing requires the IArguments shape, not a plain array.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.gtag = function gtag() {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any, prefer-rest-params
          window.dataLayer.push(arguments);
        };
      }
    });
    return _this;
  }
  _inherits(CookieBanner, _HTMLElement);
  return _createClass(CookieBanner, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.setupConsent();
            case 1:
              this.addEventListeners();
              this.activateTab("consent");
              this.syncCheckboxGroups();
              _t4 = this.dataset.forceShow === "true";
              if (_t4) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return this.shouldShowBanner();
            case 2:
              _t4 = _context5.v;
            case 3:
              if (!_t4) {
                _context5.n = 4;
                break;
              }
              this.showBanner();
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "overlay",
    get: function get() {
      var _this$querySelector0;
      return (_this$querySelector0 = this.querySelector("[data-cookie-overlay]")) !== null && _this$querySelector0 !== void 0 ? _this$querySelector0 : this;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/CustomFilters/CustomFilters.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/CustomFilters/CustomFilters.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CustomFilters)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var CustomFilters = /*#__PURE__*/function (_HTMLElement) {
  function CustomFilters() {
    var _this;
    _classCallCheck(this, CustomFilters);
    _this = _callSuper(this, CustomFilters);
    _defineProperty(_this, "customFilterOptions", void 0);
    _defineProperty(_this, "customPriceFilterInputs", void 0);
    _defineProperty(_this, "collectionurl", void 0);
    _defineProperty(_this, "params", void 0);
    _defineProperty(_this, "applyPriceFilterButton", void 0);
    _defineProperty(_this, "pendingFiltersByCategory", new Map());
    // Range slider elements
    _defineProperty(_this, "minRangeInput", void 0);
    _defineProperty(_this, "maxRangeInput", void 0);
    _defineProperty(_this, "minThumb", void 0);
    _defineProperty(_this, "maxThumb", void 0);
    _defineProperty(_this, "progressBar", void 0);
    _defineProperty(_this, "minPriceInput", void 0);
    _defineProperty(_this, "maxPriceInput", void 0);
    _this.initData = _this.initData.bind(_this);
    _this.updateRangeSlider = _this.updateRangeSlider.bind(_this);
    _this.handleRangeInput = _this.handleRangeInput.bind(_this);
    _this.handlePriceInput = _this.handlePriceInput.bind(_this);
    return _this;
  }
  _inherits(CustomFilters, _HTMLElement);
  return _createClass(CustomFilters, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initData();
      this.initRangeSlider();
      this.addEventlisteners();
      this.readPriceFromURL();
      this.initializePendingFilters();
    }
  }, {
    key: "initData",
    value: function initData() {
      this.customFilterOptions = Array.from(this.querySelectorAll(".custom-filter-option"));
      this.customPriceFilterInputs = Array.from(this.querySelectorAll(".custom-price-filter"));
      this.applyPriceFilterButton = this.querySelector("#apply-price-filter");
      this.collectionurl = this.dataset.collectionurl;
      // Range slider elements
      this.minRangeInput = this.querySelector(".min-range-input");
      this.maxRangeInput = this.querySelector(".max-range-input");
      this.minThumb = this.querySelector(".min-thumb");
      this.maxThumb = this.querySelector(".max-thumb");
      this.progressBar = this.querySelector(".price-range-progress");
      this.minPriceInput = this.querySelector(".min-price-input");
      this.maxPriceInput = this.querySelector(".max-price-input");
    }
  }, {
    key: "initRangeSlider",
    value: function initRangeSlider() {
      this.updateRangeSlider();
    }
  }, {
    key: "readPriceFromURL",
    value: function readPriceFromURL() {
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      var minPrice = params.get("filter.v.price.gte");
      var maxPrice = params.get("filter.v.price.lte");
      if (minPrice && maxPrice) {
        // Update number inputs
        this.minPriceInput.value = minPrice;
        this.maxPriceInput.value = maxPrice;
        // Update range inputs
        this.minRangeInput.value = minPrice;
        this.maxRangeInput.value = maxPrice;
        // Update slider UI
        this.updateRangeSlider();
      }
    }
  }, {
    key: "updateRangeSlider",
    value: function updateRangeSlider() {
      var minVal = parseInt(this.minRangeInput.value, 10);
      var maxVal = parseInt(this.maxRangeInput.value, 10);
      var min = parseInt(this.minRangeInput.min, 10);
      var max = parseInt(this.minRangeInput.max, 10);
      // Calculate percentages for positioning
      var minPercent = (minVal - min) / (max - min) * 100;
      var maxPercent = (maxVal - min) / (max - min) * 100;
      // Update thumb positions
      this.minThumb.style.left = "".concat(minPercent, "%");
      this.maxThumb.style.left = "".concat(maxPercent, "%");
      // Update progress bar
      this.progressBar.style.left = "".concat(minPercent, "%");
      this.progressBar.style.right = "".concat(100 - maxPercent, "%");
      // Update number inputs to match range inputs
      this.minPriceInput.value = minVal.toString();
      this.maxPriceInput.value = maxVal.toString();
    }
  }, {
    key: "handleRangeInput",
    value: function handleRangeInput(event) {
      var target = event.target;
      var isMin = target.dataset.type === "min";
      var minVal = parseInt(this.minRangeInput.value, 10);
      var maxVal = parseInt(this.maxRangeInput.value, 10);
      // Prevent crossing of min and max
      if (isMin) {
        minVal = Math.min(minVal, maxVal - 1);
        this.minRangeInput.value = minVal.toString();
      } else {
        maxVal = Math.max(maxVal, minVal + 1);
        this.maxRangeInput.value = maxVal.toString();
      }
      this.updateRangeSlider();
    }
  }, {
    key: "handlePriceInput",
    value: function handlePriceInput(event) {
      var target = event.target;
      var isMin = target.classList.contains("min-price-input");
      var minVal = parseInt(this.minPriceInput.value, 10) || 0;
      var maxVal = parseInt(this.maxPriceInput.value, 10) || parseInt(this.maxRangeInput.max, 10);
      var minLimit = parseInt(this.minRangeInput.min, 10);
      var maxLimit = parseInt(this.minRangeInput.max, 10);
      // Clamp values to min/max limits
      minVal = Math.max(minLimit, Math.min(maxLimit, minVal));
      maxVal = Math.max(minLimit, Math.min(maxLimit, maxVal));
      // Prevent crossing
      if (isMin) {
        minVal = Math.min(minVal, maxVal - 1);
      } else {
        maxVal = Math.max(maxVal, minVal + 1);
      }
      // Update both number and range inputs
      this.minPriceInput.value = minVal.toString();
      this.maxPriceInput.value = maxVal.toString();
      this.minRangeInput.value = minVal.toString();
      this.maxRangeInput.value = maxVal.toString();
      this.updateRangeSlider();
    }
  }, {
    key: "addEventlisteners",
    value: function addEventlisteners() {
      var _this2 = this;
      this.customFilterOptions.forEach(function (filterOption) {
        filterOption.addEventListener("change", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _context.n = 1;
                return _this2.toggleFilter(filterOption);
              case 1:
                return _context.a(2);
            }
          }, _callee);
        })));
      });
      this.applyPriceFilterButton.addEventListener("click", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                event.preventDefault();
                _this2.applyPriceFilter();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
      // Add event listeners for category-specific apply buttons
      this.addCategoryApplyButtonListeners();
      // Range slider events
      this.minRangeInput.addEventListener("input", this.handleRangeInput);
      this.maxRangeInput.addEventListener("input", this.handleRangeInput);
      // Number input events
      this.minPriceInput.addEventListener("input", this.handlePriceInput);
      this.maxPriceInput.addEventListener("input", this.handlePriceInput);
      // Thumb drag events
      this.addThumbDragEvents(this.minThumb, this.minRangeInput);
      this.addThumbDragEvents(this.maxThumb, this.maxRangeInput);
    }
  }, {
    key: "addThumbDragEvents",
    value: function addThumbDragEvents(thumb, rangeInput) {
      var _this3 = this;
      var isDragging = false;
      var onDrag = function onDrag(e) {
        if (!isDragging) return;
        var sliderRect = thumb.closest(".price-range-slider-container").getBoundingClientRect();
        var clientX = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX;
        var percent = Math.max(0, Math.min(1, (clientX - sliderRect.left) / sliderRect.width));
        var min = parseInt(rangeInput.min, 10);
        var max = parseInt(rangeInput.max, 10);
        var value = Math.round(min + percent * (max - min));
        rangeInput.value = value.toString();
        _this3.handleRangeInput({
          target: rangeInput
        });
      };
      var _stopDrag = function stopDrag() {
        isDragging = false;
        document.removeEventListener("mousemove", onDrag);
        document.removeEventListener("touchmove", onDrag);
        document.removeEventListener("mouseup", _stopDrag);
        document.removeEventListener("touchend", _stopDrag);
      };
      var startDrag = function startDrag(e) {
        isDragging = true;
        document.addEventListener("mousemove", onDrag);
        document.addEventListener("touchmove", onDrag);
        document.addEventListener("mouseup", _stopDrag);
        document.addEventListener("touchend", _stopDrag);
        e.preventDefault();
      };
      thumb.addEventListener("mousedown", startDrag);
      thumb.addEventListener("touchstart", startDrag);
    }
  }, {
    key: "applyPriceFilter",
    value: function applyPriceFilter() {
      var minValue = this.minPriceInput.value;
      var maxValue = this.maxPriceInput.value;
      // Update the URL parameters
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      params.set("filter.v.price.gte", minValue);
      params.set("filter.v.price.lte", maxValue);
      url.search = params.toString();
      this.params = params.toString();
      window.history.pushState({}, "", url.toString());
      this.reloadCollectionPage();
    }
  }, {
    key: "toggleFilter",
    value: function () {
      var _toggleFilter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(checkbox) {
        var name, value, categoryId, categoryFilters, url, params, currentAppliedValues, pendingValues, index, hasChanges;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              name = checkbox.name, value = checkbox.value;
              categoryId = CustomFilters.getCategoryIdFromCheckbox(checkbox); // Update visual state for color swatches
              CustomFilters.updateColorSwatchVisualState(checkbox);
              // Store pending filter changes by category
              if (!this.pendingFiltersByCategory.has(categoryId)) {
                this.pendingFiltersByCategory.set(categoryId, new Map());
              }
              categoryFilters = this.pendingFiltersByCategory.get(categoryId); // Get current URL state to track what's actually applied
              url = new URL(window.location.href);
              params = new URLSearchParams(url.search);
              currentAppliedValues = params.getAll(name); // Initialize pending values with current applied state if not tracking yet
              if (!categoryFilters.has(name)) {
                categoryFilters.set(name, _toConsumableArray(currentAppliedValues));
              }
              pendingValues = categoryFilters.get(name);
              if (checkbox.checked) {
                // User wants this value selected
                if (!pendingValues.includes(value)) {
                  pendingValues.push(value);
                }
              } else {
                // User wants this value deselected
                index = pendingValues.indexOf(value);
                if (index > -1) {
                  pendingValues.splice(index, 1);
                }
              }
              // Check if there are actual changes from the applied state
              hasChanges = !CustomFilters.arraysEqual(pendingValues.sort(), currentAppliedValues.sort());
              if (!hasChanges) {
                // No changes from current state, remove from tracking
                categoryFilters["delete"](name);
              }
              // Clean up empty category
              if (categoryFilters.size === 0) {
                this.pendingFiltersByCategory["delete"](categoryId);
              }
              this.updateCategoryApplyButtonState(categoryId);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function toggleFilter(_x2) {
        return _toggleFilter.apply(this, arguments);
      }
      return toggleFilter;
    }()
  }, {
    key: "reloadCollectionPage",
    value: function () {
      var _reloadCollectionPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var response, text, parser, doc, newCollectionGrid, currentCollectionGrid, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return fetch("/collections/".concat(this.collectionurl, "?").concat(this.params));
            case 1:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 2;
                break;
              }
              throw new Error("error occured");
            case 2:
              _context4.n = 3;
              return response.text();
            case 3:
              text = _context4.v;
              parser = new DOMParser();
              doc = parser.parseFromString(text, "text/html");
              newCollectionGrid = doc.querySelector("#CollectionAjaxContent");
              currentCollectionGrid = document.querySelector("#CollectionAjaxContent");
              if (newCollectionGrid && currentCollectionGrid) {
                currentCollectionGrid.innerHTML = newCollectionGrid.innerHTML;
                currentCollectionGrid.classList.add("collection-updated");
                // Re-initialize desktop filter management after DOM update
                this.initializeDesktopFilterBehavior();
              }
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
              // eslint-disable-next-line no-console
              console.log("error", _t);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 4]]);
      }));
      function reloadCollectionPage() {
        return _reloadCollectionPage.apply(this, arguments);
      }
      return reloadCollectionPage;
    }()
  }, {
    key: "addCategoryApplyButtonListeners",
    value: function addCategoryApplyButtonListeners() {
      var _this4 = this;
      var applyButtons = this.querySelectorAll(".category-apply-button");
      applyButtons.forEach(function (button) {
        button.addEventListener("click", /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(event) {
            var categoryId;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  event.preventDefault();
                  categoryId = button.dataset.categoryId;
                  _context5.n = 1;
                  return _this4.applyCategoryFilters(categoryId);
                case 1:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "applyCategoryFilters",
    value: function () {
      var _applyCategoryFilters = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(categoryId) {
        var url, params, categoryFilters;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              url = new URL(window.location.href);
              params = new URLSearchParams(url.search);
              categoryFilters = this.pendingFiltersByCategory.get(categoryId);
              if (!categoryFilters) {
                _context6.n = 1;
                break;
              }
              // Apply all pending filters for this category
              categoryFilters.forEach(function (values, name) {
                // First remove ALL existing parameters for this filter type
                params["delete"](name);
                // Then add only the selected values (empty array means deselect all)
                values.forEach(function (value) {
                  params.append(name, value);
                });
              });
              url.search = params.toString();
              this.params = params.toString();
              window.history.pushState({}, "", url.toString());
              // Clear pending filters for this category
              this.pendingFiltersByCategory["delete"](categoryId);
              this.updateCategoryApplyButtonState(categoryId);
              _context6.n = 1;
              return this.reloadCollectionPage();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function applyCategoryFilters(_x4) {
        return _applyCategoryFilters.apply(this, arguments);
      }
      return applyCategoryFilters;
    }()
  }, {
    key: "updateCategoryApplyButtonState",
    value: function updateCategoryApplyButtonState(categoryId) {
      var applyButton = this.querySelector("[data-category-id=\"".concat(categoryId, "\"]"));
      if (applyButton) {
        var categoryFilters = this.pendingFiltersByCategory.get(categoryId);
        var hasPendingChanges = categoryFilters && categoryFilters.size > 0;
        // Always show the button
        applyButton.style.display = "block";
        if (hasPendingChanges) {
          var count = this.getCategoryPendingCount(categoryId);
          applyButton.textContent = "".concat(window.translationStrings.apply, " (").concat(count, ")");
          applyButton.classList.add("has-changes");
        } else {
          applyButton.textContent = window.translationStrings.apply;
          applyButton.classList.remove("has-changes");
        }
      }
    }
  }, {
    key: "getCategoryPendingCount",
    value: function getCategoryPendingCount(categoryId) {
      var categoryFilters = this.pendingFiltersByCategory.get(categoryId);
      if (!categoryFilters) return 0;
      var total = 0;
      categoryFilters.forEach(function (values) {
        total += values.length;
      });
      return total;
    }
  }, {
    key: "initializePendingFilters",
    value: function initializePendingFilters() {
      // Initialize pending filters to be empty - user starts with a clean slate
      this.pendingFiltersByCategory.clear();
      // Make sure all apply buttons are visible
      var applyButtons = this.querySelectorAll(".category-apply-button");
      applyButtons.forEach(function (button) {
        button.style.display = "block";
        button.textContent = window.translationStrings.apply;
      });
      // Restore visual states for all color swatches based on their checked state
      this.customFilterOptions.forEach(function (filterOption) {
        CustomFilters.updateColorSwatchVisualState(filterOption);
      });
    }
  }, {
    key: "initializeDesktopFilterBehavior",
    value: function initializeDesktopFilterBehavior() {
      // Re-initialize all component references after AJAX reload
      this.initData();
      // Re-initialize desktop filter management after AJAX reload
      var desktopFilters = document.querySelectorAll(".desktop-filter");
      // Close other filters when one opens
      desktopFilters.forEach(function (filter) {
        filter.addEventListener("toggle", function (event) {
          var targetFilter = event.target;
          if (targetFilter.open) {
            // Close all other filters
            desktopFilters.forEach(function (otherFilter) {
              if (otherFilter !== targetFilter && otherFilter.open) {
                otherFilter.open = false;
              }
            });
          }
        });
      });
      // Re-add all event listeners
      this.addEventlisteners();
      // Clear pending filters as we're starting fresh with the new DOM
      this.pendingFiltersByCategory.clear();
      // Reset all apply buttons to default state
      var applyButtons = this.querySelectorAll(".category-apply-button");
      applyButtons.forEach(function (button) {
        button.textContent = window.translationStrings.apply;
        button.classList.remove("has-changes");
      });
      // Restore visual states for all color swatches based on their checked state
      this.customFilterOptions.forEach(function (filterOption) {
        CustomFilters.updateColorSwatchVisualState(filterOption);
      });
    }
  }], [{
    key: "getCategoryIdFromCheckbox",
    value: function getCategoryIdFromCheckbox(checkbox) {
      // Find the closest desktop-filter parent to get the category ID
      var filterPanel = checkbox.closest(".desktop-filter__panel");
      if (filterPanel) {
        return filterPanel.id || "unknown";
      }
      return "unknown";
    }
  }, {
    key: "updateColorSwatchVisualState",
    value: function updateColorSwatchVisualState(checkbox) {
      var colorSwatch = checkbox.closest(".desktop-filter__color-swatch");
      if (colorSwatch) {
        if (checkbox.checked) {
          colorSwatch.classList.add("selected");
          colorSwatch.classList.add("tw:ring-2", "tw:ring-black", "tw:bg-[#E5DACD]");
          colorSwatch.classList.remove("tw:bg-[#F4EBE2]");
        } else {
          colorSwatch.classList.remove("selected");
          colorSwatch.classList.remove("tw:ring-2", "tw:ring-black", "tw:bg-[#E5DACD]");
          colorSwatch.classList.add("tw:bg-[#F4EBE2]");
        }
      }
    }
  }, {
    key: "arraysEqual",
    value: function arraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      return arr1.every(function (value, index) {
        return value === arr2[index];
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/DataLayer/DataLayer.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/DataLayer.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEBUG_MODE": () => (/* binding */ DEBUG_MODE),
/* harmony export */   "DataLayer": () => (/* binding */ DataLayer)
/* harmony export */ });
/* harmony import */ var _utils_Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/Logger */ "./resources/scripts/utils/Logger.ts");
/* harmony import */ var _utils_Storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @utils/Storage */ "./resources/scripts/utils/Storage.ts");
/* harmony import */ var _utils_datalayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @utils/datalayer */ "./resources/scripts/utils/datalayer/dataLayerLogger.ts");
/* harmony import */ var _utils_datalayer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @utils/datalayer */ "./resources/scripts/utils/datalayer/normalizeShopifyId.ts");
/* harmony import */ var _utils_datalayer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @utils/datalayer */ "./resources/scripts/utils/datalayer/toAbsoluteUrl.ts");
/* harmony import */ var _utils_sha256__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @utils/sha256 */ "./resources/scripts/utils/sha256.ts");
/* harmony import */ var _cartInterceptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cartInterceptor */ "./resources/scripts/components/DataLayer/cartInterceptor.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }





// Set to false before going live
var DEBUG_MODE = false;
var CONSENT_STORAGE_KEY = "cookieSelections";
var DL_QUEUE = {
  KEY: "dl_pending_queue",
  TTL_MINUTES: 30,
  MAX_SIZE: 20
};
var PAGE_DATA_DEFAULTS = {
  pageType: "other",
  product: null,
  collection: null,
  searchQuery: null,
  customer: null
};
/**
 * Consent-aware theme dataLayer — collects page, user, and ecommerce events
 * and pushes them to `window.dataLayer` for GTM consumption.
 *
 * Initialisation is deferred until `CookieBanner` fires `edition:consent-default-set`,
 * guaranteeing Consent Mode v2 defaults are applied before any event is pushed.
 * Events that require analytics consent but arrive before it is granted are held
 * in `localStorage` (30-minute TTL, max 20 events) and flushed automatically when `edition:consent-updated` fires.
 *
 * Page-scoped data (product, collection, customer) is read from the
 * `#datalayer-data` JSON script tag rendered by `datalayer-data.liquid`.
 *
 * @example
 * ```ts
 * // app.ts
 * const dataLayer = new DataLayer();
 * dataLayer.init();
 * ```
 *
 * @example
 * ```ts
 * // Trigger a cart view from a cart drawer component
 * window.editionDataLayer?.trackCartView();
 * ```
 *
 * @see {@link https://developers.google.com/tag-platform/devguides/consent} Consent Mode v2
 */
var DataLayer = /*#__PURE__*/_createClass(function DataLayer() {
  var _this = this;
  _classCallCheck(this, DataLayer);
  /**
   * Registers the two window event listeners that drive the lifecycle.
   * Must be called once from `app.ts` — safe to call before `CookieBanner` connects.
   *
   * - `edition:consent-default-set` → runs full initialisation (once).
   * - `edition:consent-updated`     → flushes the session queue.
   */
  _defineProperty(this, "init", function () {
    window.addEventListener("edition:consent-default-set", function () {
      _this.initialize()["catch"](function (err) {
        return _utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("DataLayer init failed", err);
      });
    }, {
      once: true
    });
    window.addEventListener("edition:consent-updated", function () {
      _this.flushQueue();
    });
  });
  /** Runs the full initialisation sequence — pushes context, user, and page events then wires up interceptors. */
  _defineProperty(this, "initialize", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var pageData;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          window.dataLayer = window.dataLayer || [];
          pageData = _this.readPageData();
          _this.pushLocation();
          _this.pushContextData({
            pageType: pageData.pageType
          });
          _this.pushDeviceData();
          if (!pageData.customer) {
            _context.n = 1;
            break;
          }
          _context.n = 1;
          return _this.pushUserData({
            customer: pageData.customer
          });
        case 1:
          _context.n = 2;
          return _this.pushPageTypeEvent({
            pageData: pageData
          });
        case 2:
          (0,_cartInterceptor__WEBPACK_IMPORTED_MODULE_1__.initCartInterceptor)({
            onAddToCart: function onAddToCart(payload) {
              return _this.pushToDataLayer({
                payload: payload,
                consentRequirement: "analytics"
              });
            },
            onRemoveFromCart: function onRemoveFromCart(payload) {
              return _this.pushToDataLayer({
                payload: payload,
                consentRequirement: "analytics"
              });
            }
          });
          _this.bindFormListeners();
          window.editionDataLayer = {
            trackCartView: _this.trackCartView,
            trackAddToCart: _this.trackAddToCart,
            trackRemoveFromCart: _this.trackRemoveFromCart
          };
          if (DEBUG_MODE) {
            (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
              category: "init",
              label: "DataLayer initialized",
              payload: {
                pageType: pageData.pageType
              }
            });
          }
        case 3:
          return _context.a(2);
      }
    }, _callee);
  })));
  /** Parses the `#datalayer-data` JSON script tag injected by `datalayer-data.liquid`. Returns safe defaults on failure. */
  // eslint-disable-next-line class-methods-use-this
  _defineProperty(this, "readPageData", function () {
    var el = document.getElementById("datalayer-data");
    if (!(el !== null && el !== void 0 && el.textContent)) {
      return PAGE_DATA_DEFAULTS;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (_unused) {
      _utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].warn("Failed to parse #datalayer-data JSON");
      return PAGE_DATA_DEFAULTS;
    }
  });
  /**
   * Pushes a payload to `window.dataLayer` if the required consent is granted,
   * otherwise holds it in `sessionStorage` for later flushing.
   */
  _defineProperty(this, "pushToDataLayer", function (_ref2) {
    var payload = _ref2.payload,
      consentRequirement = _ref2.consentRequirement;
    var isEvent = payload.event.startsWith("edition_");
    if (_this.checkConsent({
      requirement: consentRequirement
    })) {
      window.dataLayer.push(payload);
      if (DEBUG_MODE) {
        (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
          category: isEvent ? "event" : "context",
          label: payload.event,
          payload: payload
        });
      }
    } else {
      _this.queueEvent({
        payload: payload,
        consentRequirement: consentRequirement
      });
      if (DEBUG_MODE) {
        (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
          category: "config",
          label: "Queued (no consent): ".concat(payload.event),
          payload: payload
        });
      }
    }
  });
  /** Reads consent state from localStorage — same key written by `CookieBanner`. */
  // eslint-disable-next-line class-methods-use-this
  _defineProperty(this, "checkConsent", function (_ref3) {
    var requirement = _ref3.requirement;
    if (requirement === "none") {
      return true;
    }
    var selections = _utils_Storage__WEBPACK_IMPORTED_MODULE_3__.local.get(CONSENT_STORAGE_KEY);
    if (!selections) {
      return false;
    }
    if (requirement === "analytics") {
      return selections.analytics;
    }
    if (requirement === "marketing") {
      return selections.marketing;
    }
    return false;
  });
  /** Appends an event to the queue, dropping the oldest if the cap is reached. Persists for 30 minutes across page loads. */
  _defineProperty(this, "queueEvent", function (event) {
    var queue = _this.getQueue();
    if (queue.length >= DL_QUEUE.MAX_SIZE) {
      queue.shift();
    }
    queue.push(event);
    _utils_Storage__WEBPACK_IMPORTED_MODULE_3__.local.set(DL_QUEUE.KEY, queue, DL_QUEUE.TTL_MINUTES);
  });
  /** Returns the current queue from localStorage, or an empty array if nothing is queued or TTL has expired. */
  // eslint-disable-next-line class-methods-use-this
  _defineProperty(this, "getQueue", function () {
    var _local$get;
    return (_local$get = _utils_Storage__WEBPACK_IMPORTED_MODULE_3__.local.get(DL_QUEUE.KEY)) !== null && _local$get !== void 0 ? _local$get : [];
  });
  /**
   * Replays all queued events that now have consent, leaving the rest in place.
   * Called automatically on `edition:consent-updated`.
   */
  _defineProperty(this, "flushQueue", function () {
    var queue = _this.getQueue();
    if (!queue.length) {
      return;
    }
    var remaining = [];
    queue.forEach(function (_ref4) {
      var payload = _ref4.payload,
        consentRequirement = _ref4.consentRequirement;
      if (_this.checkConsent({
        requirement: consentRequirement
      })) {
        _this.refreshTimestamp(payload);
        window.dataLayer.push(payload);
        if (DEBUG_MODE) {
          (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
            category: "event",
            label: "Flushed: ".concat(payload.event),
            payload: payload
          });
        }
      } else {
        remaining.push({
          payload: payload,
          consentRequirement: consentRequirement
        });
      }
    });
    _utils_Storage__WEBPACK_IMPORTED_MODULE_3__.local.set(DL_QUEUE.KEY, remaining, DL_QUEUE.TTL_MINUTES);
    var flushed = queue.length - remaining.length;
    if (flushed > 0 && DEBUG_MODE) {
      (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
        category: "init",
        label: "Flushed ".concat(flushed, " queued events"),
        payload: {
          remaining: remaining.length
        }
      });
    }
  });
  /** Queued events can be flushed up to 30 minutes after they occurred — restamp so downstream dedup windows see the flush time. */
  // eslint-disable-next-line class-methods-use-this
  _defineProperty(this, "refreshTimestamp", function (payload) {
    var now = new Date().toISOString();
    if ("ecommerce" in payload && "timestamp" in payload.ecommerce) {
      payload.ecommerce.timestamp = now;
    } else if ("timestamp" in payload) {
      payload.timestamp = now;
    }
  });
  /** Pushes the current page URL breakdown and shop domain. No consent required. */
  _defineProperty(this, "pushLocation", function () {
    var _window$Shopify$shop, _window$Shopify;
    var _window$location = window.location,
      hash = _window$location.hash,
      host = _window$location.host,
      hostname = _window$location.hostname,
      href = _window$location.href,
      origin = _window$location.origin,
      pathname = _window$location.pathname,
      port = _window$location.port,
      protocol = _window$location.protocol,
      search = _window$location.search;
    _this.pushToDataLayer({
      payload: {
        event: "location",
        location: {
          hash: hash,
          host: host,
          hostname: hostname,
          href: href,
          origin: origin,
          pathname: pathname,
          port: port,
          protocol: protocol,
          search: search
        },
        shop: (_window$Shopify$shop = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.shop) !== null && _window$Shopify$shop !== void 0 ? _window$Shopify$shop : null
      },
      consentRequirement: "none"
    });
  });
  /** Pushes page type, title, and URL. No consent required. */
  _defineProperty(this, "pushContextData", function (_ref5) {
    var pageType = _ref5.pageType;
    _this.pushToDataLayer({
      payload: {
        event: "contextData",
        page: {
          type: pageType,
          title: document.title,
          url: window.location.href
        }
      },
      consentRequirement: "none"
    });
  });
  /** Pushes browser/device signals — language, screen size, user agent, cookie state. No consent required. */
  _defineProperty(this, "pushDeviceData", function () {
    _this.pushToDataLayer({
      payload: {
        event: "deviceData",
        encoding: document.characterSet,
        language: navigator.language,
        cookieEnabled: navigator.cookieEnabled,
        screen: "".concat(window.innerWidth, "x").concat(window.innerHeight),
        userAgent: navigator.userAgent
      },
      consentRequirement: "none"
    });
  });
  /** Hashes PII fields with SHA-256 before pushing — email, phone, first/last name. */
  _defineProperty(this, "pushUserData", /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref6) {
      var _ref8, _customer$first_name, _customer$email, _customer$phone, _customer$first_name2, _customer$last_name, _addr$address, _addr$city, _addr$province, _addr$zip, _addr$country_code;
      var customer, _yield$Promise$all, _yield$Promise$all2, sha256Email, sha256Phone, sha256FirstName, sha256LastName, addr, hasAddress;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            customer = _ref6.customer;
            _context2.n = 1;
            return Promise.all([customer.email ? (0,_utils_sha256__WEBPACK_IMPORTED_MODULE_4__.sha256)(customer.email.toLowerCase().trim()) : null, customer.phone ? (0,_utils_sha256__WEBPACK_IMPORTED_MODULE_4__.sha256)(customer.phone.replace(/\D/g, "")) : null, customer.first_name ? (0,_utils_sha256__WEBPACK_IMPORTED_MODULE_4__.sha256)(customer.first_name.toLowerCase().trim()) : null, customer.last_name ? (0,_utils_sha256__WEBPACK_IMPORTED_MODULE_4__.sha256)(customer.last_name.toLowerCase().trim()) : null]);
          case 1:
            _yield$Promise$all = _context2.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
            sha256Email = _yield$Promise$all2[0];
            sha256Phone = _yield$Promise$all2[1];
            sha256FirstName = _yield$Promise$all2[2];
            sha256LastName = _yield$Promise$all2[3];
            addr = customer.default_address;
            hasAddress = Boolean((_ref8 = (_customer$first_name = customer.first_name) !== null && _customer$first_name !== void 0 ? _customer$first_name : customer.last_name) !== null && _ref8 !== void 0 ? _ref8 : addr);
            _this.pushToDataLayer({
              payload: {
                event: "userData",
                customer: {
                  id: customer.id != null ? String(customer.id) : null,
                  email: (_customer$email = customer.email) !== null && _customer$email !== void 0 ? _customer$email : null,
                  phone_number: (_customer$phone = customer.phone) !== null && _customer$phone !== void 0 ? _customer$phone : null,
                  sha256_email_address: sha256Email,
                  sha256_phone_number: sha256Phone,
                  address: hasAddress ? {
                    first_name: (_customer$first_name2 = customer.first_name) !== null && _customer$first_name2 !== void 0 ? _customer$first_name2 : null,
                    last_name: (_customer$last_name = customer.last_name) !== null && _customer$last_name !== void 0 ? _customer$last_name : null,
                    street: (_addr$address = addr === null || addr === void 0 ? void 0 : addr.address1) !== null && _addr$address !== void 0 ? _addr$address : null,
                    city: (_addr$city = addr === null || addr === void 0 ? void 0 : addr.city) !== null && _addr$city !== void 0 ? _addr$city : null,
                    region: (_addr$province = addr === null || addr === void 0 ? void 0 : addr.province) !== null && _addr$province !== void 0 ? _addr$province : null,
                    postal_code: (_addr$zip = addr === null || addr === void 0 ? void 0 : addr.zip) !== null && _addr$zip !== void 0 ? _addr$zip : null,
                    country: (_addr$country_code = addr === null || addr === void 0 ? void 0 : addr.country_code) !== null && _addr$country_code !== void 0 ? _addr$country_code : null,
                    sha256_first_name: sha256FirstName,
                    sha256_last_name: sha256LastName
                  } : null
                }
              },
              consentRequirement: "analytics"
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref7.apply(this, arguments);
    };
  }());
  /**
   * Dispatches the page-type-specific event based on `pageData.pageType`.
   * For `search`, reads `?q` from the URL rather than relying on Liquid output.
   */
  _defineProperty(this, "pushPageTypeEvent", /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref9) {
      var pageData, _URLSearchParams$get, query, exhaustiveCheck, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            pageData = _ref9.pageData;
            _t = pageData.pageType;
            _context3.n = _t === "product" ? 1 : _t === "collection" ? 2 : _t === "search" ? 3 : _t === "cart" ? 4 : _t === "other" ? 6 : 7;
            break;
          case 1:
            if (pageData.product) {
              _this.pushViewItem({
                product: pageData.product
              });
            }
            return _context3.a(3, 8);
          case 2:
            if (pageData.collection) {
              _this.pushCollectionView({
                collection: pageData.collection
              });
            }
            return _context3.a(3, 8);
          case 3:
            query = (_URLSearchParams$get = new URLSearchParams(window.location.search).get("q")) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : pageData.searchQuery;
            if (query) {
              _this.pushSearch({
                query: query
              });
            }
            return _context3.a(3, 8);
          case 4:
            _context3.n = 5;
            return _this.trackCartView();
          case 5:
            return _context3.a(3, 8);
          case 6:
            return _context3.a(3, 8);
          case 7:
            exhaustiveCheck = pageData.pageType;
            _utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].warn("Unhandled DataLayer page type", exhaustiveCheck);
          case 8:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref0.apply(this, arguments);
    };
  }());
  /** Pushes `edition_view_item` using the URL-selected variant, falling back to the first variant. Requires analytics consent. */
  _defineProperty(this, "pushViewItem", function (_ref1) {
    var _ref10, _window$Shopify$curre, _window$Shopify2, _variant$featured_ima, _variant$featured_ima2, _variant$sku;
    var product = _ref1.product;
    var urlVariantId = new URLSearchParams(window.location.search).get("variant");
    var variant = (_ref10 = urlVariantId ? product.variants.find(function (v) {
      return (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.normalizeShopifyId)(v.id) === urlVariantId;
    }) : null) !== null && _ref10 !== void 0 ? _ref10 : product.variants[0];
    if (!variant) {
      return;
    }
    _this.pushToDataLayer({
      payload: {
        event: "edition_view_item",
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          currency: (_window$Shopify$curre = (_window$Shopify2 = window.Shopify) === null || _window$Shopify2 === void 0 || (_window$Shopify2 = _window$Shopify2.currency) === null || _window$Shopify2 === void 0 ? void 0 : _window$Shopify2.active) !== null && _window$Shopify$curre !== void 0 ? _window$Shopify$curre : "",
          value: variant.price / 100,
          items: [{
            item_name: product.title,
            item_id: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.normalizeShopifyId)(product.id),
            item_brand: product.vendor,
            item_category: product.type,
            item_type: product.type,
            item_variant: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.normalizeShopifyId)(variant.id),
            item_variant_name: variant.title,
            item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_6__.toAbsoluteUrl)((_variant$featured_ima = (_variant$featured_ima2 = variant.featured_image) === null || _variant$featured_ima2 === void 0 ? void 0 : _variant$featured_ima2.src) !== null && _variant$featured_ima !== void 0 ? _variant$featured_ima : product.featured_image),
            item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_6__.toAbsoluteUrl)("/products/".concat(product.handle)),
            price: variant.price / 100,
            sku: (_variant$sku = variant.sku) !== null && _variant$sku !== void 0 ? _variant$sku : null,
            quantity: 1
          }]
        }
      },
      consentRequirement: "analytics"
    });
  });
  /** Pushes `edition_collection_view` with all currently-rendered products (first 30 from Liquid). Requires analytics consent. */
  _defineProperty(this, "pushCollectionView", function (_ref11) {
    var _window$Shopify$curre2, _window$Shopify3;
    var collection = _ref11.collection;
    var title = collection.title,
      handle = collection.handle,
      products = collection.products;
    _this.pushToDataLayer({
      payload: {
        event: "edition_collection_view",
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          currency: (_window$Shopify$curre2 = (_window$Shopify3 = window.Shopify) === null || _window$Shopify3 === void 0 || (_window$Shopify3 = _window$Shopify3.currency) === null || _window$Shopify3 === void 0 ? void 0 : _window$Shopify3.active) !== null && _window$Shopify$curre2 !== void 0 ? _window$Shopify$curre2 : "",
          value: 0,
          item_list_name: title,
          item_list_id: handle,
          item_list_products_count: products.length,
          // GA4 rejects events with more than 200 items
          items: products.flatMap(function (p) {
            return p.variants.map(function (v) {
              var _v$featured_image$src, _v$featured_image, _v$sku;
              return {
                item_name: p.title,
                item_id: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.normalizeShopifyId)(p.id),
                item_brand: p.vendor,
                item_category: p.type,
                item_type: p.type,
                item_variant: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.normalizeShopifyId)(v.id),
                item_variant_name: v.title,
                item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_6__.toAbsoluteUrl)((_v$featured_image$src = (_v$featured_image = v.featured_image) === null || _v$featured_image === void 0 ? void 0 : _v$featured_image.src) !== null && _v$featured_image$src !== void 0 ? _v$featured_image$src : p.featured_image),
                item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_6__.toAbsoluteUrl)("/products/".concat(p.handle)),
                price: v.price / 100,
                sku: (_v$sku = v.sku) !== null && _v$sku !== void 0 ? _v$sku : null
              };
            });
          }).slice(0, 200)
        }
      },
      consentRequirement: "analytics"
    });
  });
  /** Pushes `edition_search` with the query string only — no result products. Requires analytics consent. */
  _defineProperty(this, "pushSearch", function (_ref12) {
    var query = _ref12.query;
    _this.pushToDataLayer({
      payload: {
        event: "edition_search",
        search_term: query,
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href
        }
      },
      consentRequirement: "analytics"
    });
  });
  /** Fetches `/cart.json` and pushes `edition_cart_view`. Call this when a cart drawer opens. */
  _defineProperty(this, "trackCartView", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
    var response, cart, _t2;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          _context4.p = 0;
          _context4.n = 1;
          return fetch("/cart.json");
        case 1:
          response = _context4.v;
          _context4.n = 2;
          return response.json();
        case 2:
          cart = _context4.v;
          _this.pushToDataLayer({
            payload: {
              event: "edition_cart_view",
              ecommerce: {
                timestamp: new Date().toISOString(),
                url: window.location.href,
                currency: cart.currency,
                value: cart.total_price / 100,
                items: cart.items.map(function (item) {
                  var _item$featured_image;
                  return {
                    item_name: item.product_title,
                    item_id: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.normalizeShopifyId)(item.product_id),
                    item_brand: item.vendor,
                    item_category: item.product_type,
                    item_type: item.product_type,
                    item_variant: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.normalizeShopifyId)(item.variant_id),
                    item_variant_name: item.variant_title,
                    item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_6__.toAbsoluteUrl)((_item$featured_image = item.featured_image) === null || _item$featured_image === void 0 ? void 0 : _item$featured_image.url),
                    item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_6__.toAbsoluteUrl)(item.url),
                    price: item.price / 100,
                    sku: item.sku,
                    quantity: item.quantity
                  };
                })
              }
            },
            consentRequirement: "analytics"
          });
          _context4.n = 4;
          break;
        case 3:
          _context4.p = 3;
          _t2 = _context4.v;
          _utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("DataLayer: failed to fetch cart", _t2);
        case 4:
          return _context4.a(2);
      }
    }, _callee4, null, [[0, 3]]);
  })));
  /** Manually push an `edition_add_to_cart` event — use when a custom flow bypasses `/cart/add.js`. */
  _defineProperty(this, "trackAddToCart", function (payload) {
    _this.pushToDataLayer({
      payload: payload,
      consentRequirement: "analytics"
    });
  });
  /** Manually push an `edition_remove_from_cart` event — use when a custom flow bypasses `/cart/update.js`. */
  _defineProperty(this, "trackRemoveFromCart", function (payload) {
    _this.pushToDataLayer({
      payload: payload,
      consentRequirement: "analytics"
    });
  });
  /** Listens for contact form submits on `document` and distinguishes newsletter vs contact events by form fields. */
  _defineProperty(this, "bindFormListeners", function () {
    document.addEventListener("submit", function (event) {
      var _form$getAttribute;
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }
      var action = (_form$getAttribute = form.getAttribute("action")) !== null && _form$getAttribute !== void 0 ? _form$getAttribute : "";
      if (!action.includes("/contact")) {
        return;
      }
      var elements = Array.from(form.elements).filter(function (el) {
        return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement;
      });
      var getField = function getField(name) {
        var _elements$find$value, _elements$find;
        return (_elements$find$value = (_elements$find = elements.find(function (el) {
          return el.name === name;
        })) === null || _elements$find === void 0 ? void 0 : _elements$find.value) !== null && _elements$find$value !== void 0 ? _elements$find$value : null;
      };
      var isNewsletter = elements.some(function (el) {
        return el.name === "contact[tags]" && el instanceof HTMLInputElement && el.value === "newsletter";
      });
      if (isNewsletter) {
        _this.pushToDataLayer({
          payload: {
            event: "edition_newsletter_subscribe",
            timestamp: new Date().toISOString(),
            customer_email: getField("contact[email]")
          },
          consentRequirement: "analytics"
        });
      } else {
        _this.pushToDataLayer({
          payload: {
            event: "edition_contact_form_submit",
            timestamp: new Date().toISOString(),
            customer_name: getField("contact[Name]"),
            customer_email: getField("contact[email]"),
            customer_phone: getField("contact[Phone number]"),
            comment: getField("contact[Comment]")
          },
          consentRequirement: "analytics"
        });
      }
    });
  });
});

/***/ }),

/***/ "./resources/scripts/components/DataLayer/cartInterceptor.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/cartInterceptor.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "initCartInterceptor": () => (/* binding */ initCartInterceptor)
/* harmony export */ });
/* harmony import */ var _utils_datalayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/datalayer */ "./resources/scripts/utils/datalayer/normalizeShopifyId.ts");
/* harmony import */ var _utils_datalayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @utils/datalayer */ "./resources/scripts/utils/datalayer/toAbsoluteUrl.ts");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable import/prefer-default-export */

var resolveUrl = function resolveUrl(input) {
  if (typeof input === "string") {
    return input;
  }
  if (input instanceof URL) {
    return input.pathname;
  }
  return input.url;
};
var activeCurrency = function activeCurrency() {
  var _window$Shopify$curre, _window$Shopify;
  return (_window$Shopify$curre = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.currency) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.active) !== null && _window$Shopify$curre !== void 0 ? _window$Shopify$curre : "";
};
/** Reads the intended quantity per variant from the request body — the response quantity is the cart total, not what was added. */
var parseRequestQuantities = function parseRequestQuantities(init) {
  var quantities = new Map();
  var body = init === null || init === void 0 ? void 0 : init.body;
  if (!body) {
    return quantities;
  }
  try {
    if (typeof body === "string" && !body.trimStart().startsWith("{")) {
      // theme.js posts the product form url-encoded as a plain string: "id=123&quantity=2"
      var params = new URLSearchParams(body);
      var id = params.get("id");
      if (id != null) {
        quantities.set((0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(id), Number(params.get("quantity")) || 1);
      }
    } else if (typeof body === "string") {
      var parsed = JSON.parse(body);
      if (Array.isArray(parsed.items)) {
        parsed.items.forEach(function (item) {
          return quantities.set((0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(item.id), Number(item.quantity) || 1);
        });
      } else if (parsed.id != null) {
        quantities.set((0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(parsed.id), Number(parsed.quantity) || 1);
      }
    }
    if (body instanceof URLSearchParams || body instanceof FormData) {
      var _id = body.get("id");
      if (_id != null) {
        quantities.set((0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(String(_id)), Number(body.get("quantity")) || 1);
      }
    }
  } catch (_unused) {
    // fall through
  }
  return quantities;
};
var buildCartItem = function buildCartItem(item, quantity) {
  var _item$featured_image;
  return {
    item_name: item.product_title,
    item_id: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(item.product_id),
    item_brand: item.vendor,
    item_category: item.product_type,
    item_type: item.product_type,
    item_variant: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(item.variant_id),
    item_variant_name: item.variant_title,
    item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_1__.toAbsoluteUrl)((_item$featured_image = item.featured_image) === null || _item$featured_image === void 0 ? void 0 : _item$featured_image.url),
    item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_1__.toAbsoluteUrl)(item.url),
    price: item.price / 100,
    sku: item.sku,
    quantity: quantity
  };
};
var diffCart = function diffCart(_ref) {
  var snapshot = _ref.snapshot,
    newCart = _ref.newCart,
    onAddToCart = _ref.onAddToCart,
    onRemoveFromCart = _ref.onRemoveFromCart;
  var currency = activeCurrency();
  var snapshotMap = new Map(snapshot.items.map(function (item) {
    return [item.key, item];
  }));
  var newMap = new Map(newCart.items.map(function (item) {
    return [item.key, item];
  }));
  snapshotMap.forEach(function (oldItem, key) {
    var _newMap$get$quantity, _newMap$get;
    var newQty = (_newMap$get$quantity = (_newMap$get = newMap.get(key)) === null || _newMap$get === void 0 ? void 0 : _newMap$get.quantity) !== null && _newMap$get$quantity !== void 0 ? _newMap$get$quantity : 0;
    if (newQty < oldItem.quantity) {
      var qtyRemoved = oldItem.quantity - newQty;
      onRemoveFromCart({
        event: "edition_remove_from_cart",
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          currency: currency,
          value: oldItem.price / 100 * qtyRemoved,
          items: [buildCartItem(oldItem, qtyRemoved)]
        }
      });
    }
  });
  newMap.forEach(function (newItem, key) {
    var _snapshotMap$get$quan, _snapshotMap$get;
    var oldQty = (_snapshotMap$get$quan = (_snapshotMap$get = snapshotMap.get(key)) === null || _snapshotMap$get === void 0 ? void 0 : _snapshotMap$get.quantity) !== null && _snapshotMap$get$quan !== void 0 ? _snapshotMap$get$quan : 0;
    if (newItem.quantity > oldQty) {
      var qtyAdded = newItem.quantity - oldQty;
      onAddToCart({
        event: "edition_add_to_cart",
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          currency: currency,
          value: newItem.price / 100 * qtyAdded,
          items: [buildCartItem(newItem, qtyAdded)]
        }
      });
    }
  });
};
/** Patches window.fetch to intercept Shopify cart endpoints and emit add/remove events. */
var initCartInterceptor = function initCartInterceptor(_ref2) {
  var onAddToCart = _ref2.onAddToCart,
    onRemoveFromCart = _ref2.onRemoveFromCart;
  var originalFetch = window.fetch.bind(window);
  var fetchCart = function fetchCart() {
    return originalFetch("/cart.json").then(function (r) {
      return r.json();
    });
  };
  window.fetch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(input, init) {
      var url, response, requestQuantities, snapshot, _response, newCart;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            url = resolveUrl(input);
            if (!url.includes("/cart/add")) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return originalFetch(input, init);
          case 1:
            response = _context.v;
            requestQuantities = parseRequestQuantities(init);
            response.clone().json().then(function (data) {
              // /cart/add.js → { items: [...] }   /cart/add → single item object
              var items = "items" in data ? data.items : [data];
              var currency = activeCurrency();
              items.forEach(function (item) {
                var _requestQuantities$ge, _item$vendor, _item$featured_image2, _item$sku;
                var addedQuantity = (_requestQuantities$ge = requestQuantities.get((0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(item.variant_id))) !== null && _requestQuantities$ge !== void 0 ? _requestQuantities$ge : 1;
                onAddToCart({
                  event: "edition_add_to_cart",
                  ecommerce: {
                    timestamp: new Date().toISOString(),
                    url: window.location.href,
                    currency: currency,
                    value: item.price / 100 * addedQuantity,
                    items: [{
                      item_name: item.product_title,
                      item_id: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(item.product_id),
                      item_brand: (_item$vendor = item.vendor) !== null && _item$vendor !== void 0 ? _item$vendor : null,
                      item_category: item.product_type,
                      item_type: item.product_type,
                      item_variant: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.normalizeShopifyId)(item.variant_id),
                      item_variant_name: item.variant_title,
                      item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_1__.toAbsoluteUrl)((_item$featured_image2 = item.featured_image) === null || _item$featured_image2 === void 0 ? void 0 : _item$featured_image2.url),
                      item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_1__.toAbsoluteUrl)(item.url),
                      price: item.price / 100,
                      sku: (_item$sku = item.sku) !== null && _item$sku !== void 0 ? _item$sku : null,
                      quantity: addedQuantity
                    }]
                  }
                });
              });
            })["catch"](function () {});
            return _context.a(2, response);
          case 2:
            if (!(url.includes("/cart/update") || url.includes("/cart/change"))) {
              _context.n = 6;
              break;
            }
            _context.n = 3;
            return fetchCart();
          case 3:
            snapshot = _context.v;
            _context.n = 4;
            return originalFetch(input, init);
          case 4:
            _response = _context.v;
            _context.n = 5;
            return fetchCart();
          case 5:
            newCart = _context.v;
            diffCart({
              snapshot: snapshot,
              newCart: newCart,
              onAddToCart: onAddToCart,
              onRemoveFromCart: onRemoveFromCart
            });
            return _context.a(2, _response);
          case 6:
            return _context.a(2, originalFetch(input, init));
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "geolocatorScript", void 0);
    _defineProperty(_this, "countryDataArray", void 0);
    _defineProperty(_this, "geolocatorContentTemplate", void 0);
    _defineProperty(_this, "geolocatorContentPlaceholder", void 0);
    _defineProperty(_this, "modal", void 0);
    _defineProperty(_this, "closeModalButton", void 0);
    _defineProperty(_this, "closeCountryListModalButton", void 0);
    _defineProperty(_this, "countryModalToggle", void 0);
    _defineProperty(_this, "countryListModal", void 0);
    _defineProperty(_this, "countryListModalToggles", void 0);
    _defineProperty(_this, "countryListButtons", void 0);
    _defineProperty(_this, "stayButton", void 0);
    _defineProperty(_this, "leaveButton", void 0);
    _defineProperty(_this, "overlay", void 0);
    _this.getBrowsingContext = _this.getBrowsingContext.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var firstBlock, isCookied, browsingContext, activeCountry, recommendedMatch;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.initDataAndElements();
              this.addEventListeners();
              if (!(this.dataset.previewForceShow === "true")) {
                _context.n = 1;
                break;
              }
              firstBlock = this.countryDataArray[0];
              if (firstBlock) {
                this.toggleGeolocator();
                this.setupGeolocatorContent(firstBlock);
              }
              return _context.a(2);
            case 1:
              this.handleGeolocationCookie();
              isCookied = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)("geolocation");
              if (!isCookied) {
                _context.n = 2;
                break;
              }
              // eslint-disable-next-line no-console
              console.log("Geolocation cookie is set. Geolocator will not run.");
              return _context.a(2);
            case 2:
              _context.n = 3;
              return this.getBrowsingContext();
            case 3:
              browsingContext = _context.v;
              activeCountry = this.getActiveCountryAndLanguage();
              recommendedMatch = this.getRecommendedMatch(browsingContext); // If the recommended match is the same as the active country, return early as we do not need to show the geolocator
              if (!((recommendedMatch === null || recommendedMatch === void 0 ? void 0 : recommendedMatch.handle) === activeCountry.country)) {
                _context.n = 4;
                break;
              }
              // eslint-disable-next-line no-console
              console.log("Recommended match is the same as the active country. Geolocator will not run.");
              return _context.a(2);
            case 4:
              this.toggleGeolocator();
              this.setupGeolocatorContent(recommendedMatch);
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "handleGeolocationCookie",
    value: function handleGeolocationCookie() {
      var urlParams = new URLSearchParams(window.location.search);
      var geolocation = urlParams.get("geolocation");
      if (geolocation) {
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", geolocation, 30);
      }
    }
  }, {
    key: "toggleGeolocator",
    value: function toggleGeolocator() {
      var _this2 = this;
      this.classList.toggle("tw:hidden");
      this.setAttribute("geolocation-modal-active", this.getAttribute("geolocation-modal-active") === "true" ? "false" : "true");
      setTimeout(function () {
        _this2.modal.classList.toggle("active");
      }, 300);
    }
  }, {
    key: "setupGeolocatorContent",
    value: function setupGeolocatorContent(recommendedMatch) {
      var _this3 = this;
      var geolocatorContent = this.geolocatorContentTemplate.content.cloneNode(true);
      var content = geolocatorContent.querySelector("[data-id=\"".concat(recommendedMatch.id, "\"]"));
      if (content) {
        this.geolocatorContentPlaceholder.appendChild(content);
      }
      this.countryModalToggle = this.querySelector(".country-modal-toggle");
      this.stayButton = this.querySelector(".stay-button");
      this.leaveButton = this.querySelector(".leave-button");
      this.countryModalToggle.addEventListener("click", function (event) {
        event.preventDefault();
        _this3.toggleCountryListModal(_this3.countryModalToggle);
      });
      this.stayButton.addEventListener("click", function (event) {
        event.preventDefault();
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", recommendedMatch.handle, 30);
        _this3.toggleGeolocator();
      });
      this.leaveButton.addEventListener("click", function (event) {
        event.preventDefault();
        var _this3$leaveButton$da = _this3.leaveButton.dataset,
          locale = _this3$leaveButton$da.locale,
          handle = _this3$leaveButton$da.handle,
          type = _this3$leaveButton$da.type,
          url = _this3$leaveButton$da.url;
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", handle, 30);
        var isMarket = type === "market";
        if (!isMarket) {
          // For country type, use the external URL if provided
          if (url) {
            window.location.href = url;
          } else {
            window.location.href = "".concat(window.location.href, "?geolocation=").concat(handle);
          }
          return;
        }
        _this3.handleMarketSwitch(handle, locale);
      });
    }
  }, {
    key: "toggleCountryListModal",
    value: function toggleCountryListModal(trigger) {
      var geoLocatorActive = this.getAttribute("geolocation-modal-active") === "true";
      // make it boolean
      var isInModalTrigger = trigger.dataset.inmodaltoggle === "true";
      if (isInModalTrigger && !geoLocatorActive) {
        this.classList.toggle("tw:hidden");
        this.countryListModal.classList.toggle("active");
        return;
      }
      if (isInModalTrigger) {
        this.modal.classList.toggle("active");
        this.countryListModal.classList.toggle("active");
      } else {
        this.classList.toggle("tw:hidden");
        this.countryListModal.classList.add("active");
      }
    }
  }, {
    key: "initDataAndElements",
    value: function initDataAndElements() {
      this.modal = this.querySelector("#geolocator-modal");
      this.closeModalButton = this.querySelector("#close-geolocator-modal");
      this.geolocatorScript = this.querySelector("#geolocator-script");
      this.countryDataArray = JSON.parse(this.geolocatorScript.innerHTML);
      this.geolocatorContentTemplate = this.querySelector("#geolocator-content-tempalte");
      this.geolocatorContentPlaceholder = this.querySelector("#geolocator-content-placeholder");
      this.countryListModal = this.querySelector("#geolocator-countrylist-modal");
      this.closeCountryListModalButton = this.querySelector("#close-geolocator-countrylist-modal");
      this.countryListButtons = Array.from(this.querySelectorAll(".countrylist-button"));
      this.countryListModalToggles = Array.from(document.querySelectorAll(".country-modal-toggle"));
      this.overlay = this.querySelector(".geolocator-overlay");
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$closeModalButto,
        _this4 = this;
      (_this$closeModalButto = this.closeModalButton) === null || _this$closeModalButto === void 0 || _this$closeModalButto.addEventListener("click", function (event) {
        event.preventDefault();
        _this4.toggleGeolocator();
      });
      this.closeCountryListModalButton.addEventListener("click", function (event) {
        event.preventDefault();
        _this4.toggleCountryListModal(_this4.closeCountryListModalButton);
      });
      this.countryListButtons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          _this4.handleCountryListButtonClick(button);
        });
      });
      this.countryListModalToggles.forEach(function (toggle) {
        toggle === null || toggle === void 0 || toggle.addEventListener("click", function (event) {
          event.preventDefault();
          _this4.toggleCountryListModal(toggle);
        });
      });
    }
  }, {
    key: "handleCountryListButtonClick",
    value: function handleCountryListButtonClick(button) {
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", button.dataset.handle, 30);
      var isMarket = button.dataset.type === "market";
      if (!isMarket) {
        // For country type, use the external URL if provided
        var url = button.dataset.url;
        if (url) {
          window.location.href = url;
        } else {
          window.location.href = "".concat(window.location.href, "?geolocation=").concat(button.dataset.handle);
        }
        return;
      }
      var _button$dataset = button.dataset,
        locale = _button$dataset.locale,
        handle = _button$dataset.handle;
      this.handleMarketSwitch(handle, locale);
    }
  }, {
    key: "handleMarketSwitch",
    value: function handleMarketSwitch(handle, locale) {
      var formId = crypto.randomUUID();
      var formElement = document.createElement("form");
      formElement.id = formId;
      formElement.action = "/localization";
      formElement.method = "POST";
      formElement.hidden = true;
      formElement.innerHTML = "\n      <input name=\"_method\" value=\"PUT\">\n      <input name=\"country_code\" value=\"".concat(handle, "\">\n      <input name=\"language_code\" value=\"").concat(locale, "\">\n      <input name=\"return_to\" value=\"").concat(window.location.href, "?geolocation=").concat(handle, "\">\n    ");
      document.body.appendChild(formElement);
      formElement.submit();
    }
  }, {
    key: "getActiveCountryAndLanguage",
    value: function getActiveCountryAndLanguage() {
      var _window$Shopify = window.Shopify,
        country = _window$Shopify.country,
        locale = _window$Shopify.locale;
      return {
        country: country,
        locale: locale
      };
    }
  }, {
    key: "getRecommendedMatch",
    value: function getRecommendedMatch(browsingContext) {
      if (!browsingContext) return; // If no browsing context, return early
      var suggestedCountry = browsingContext.suggestedCountry,
        suggestedLanguage = browsingContext.suggestedLanguage,
        detectedCountry = browsingContext.detectedCountry;
      var countryHandle = (suggestedCountry === null || suggestedCountry === void 0 ? void 0 : suggestedCountry.handle) || (detectedCountry === null || detectedCountry === void 0 ? void 0 : detectedCountry.handle);
      var languageHandle = suggestedLanguage === null || suggestedLanguage === void 0 ? void 0 : suggestedLanguage.handle;
      if (!countryHandle) return;
      // Helper function to parse countries string into array
      var parseCountries = function parseCountries(countriesStr) {
        if (!countriesStr) return [];
        return countriesStr.split(",").map(function (c) {
          return c.trim().toUpperCase();
        }).filter(function (c) {
          return c.length > 0;
        });
      };
      // Helper function to check if a country is in a market's country list
      var isCountryInMarket = function isCountryInMarket(market, country) {
        var countries = parseCountries(market.countries || "");
        // If no countries defined, check if handle matches (single-country market)
        if (countries.length === 0) {
          return market.handle.toUpperCase() === country.toUpperCase();
        }
        // Check if country is in the list
        return countries.includes(country.toUpperCase());
      };
      // Look for an exact match (country in market's country list & matching language)
      var recommendedMatch = this.countryDataArray.find(function (market) {
        return isCountryInMarket(market, countryHandle) && market.locale === languageHandle;
      });
      // If no exact match, look for a market that contains this country (any language)
      if (!recommendedMatch) {
        recommendedMatch = this.countryDataArray.find(function (market) {
          return isCountryInMarket(market, countryHandle);
        });
      }
      // If still no match, find the primary market
      if (!recommendedMatch) {
        recommendedMatch = this.countryDataArray.find(function (market) {
          return market.primary;
        });
      }
      // In the end we either have
      // 1. An exact match on country (in market's country list) and language
      // 2. A match on country only (in market's country list)
      // 3. A match on primary market
      // eslint-disable-next-line consistent-return
      return recommendedMatch;
    }
  }, {
    key: "getBrowsingContext",
    value: function () {
      var _getBrowsingContext = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, detectedValues, _detectedValues$count, handle, name, suggestions, suggestedCountry, suggestedLanguage, suggestion, browsingContext;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch("/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true");
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              detectedValues = data.detected_values;
              _detectedValues$count = detectedValues.country, handle = _detectedValues$count.handle, name = _detectedValues$count.name;
              suggestions = data.suggestions;
              suggestedCountry = null;
              suggestedLanguage = null;
              if (suggestions.length) {
                // Check if there is a suggestion who has parts.country.handle which is equal to detectedValues.country.handle
                suggestion = suggestions.find(function (_suggestion) {
                  return _suggestion.parts.country.handle === detectedValues.country.handle;
                });
                suggestedCountry = suggestion === null || suggestion === void 0 ? void 0 : suggestion.parts.country;
                suggestedLanguage = suggestion === null || suggestion === void 0 ? void 0 : suggestion.parts.language;
              }
              browsingContext = {
                detectedCountry: {
                  handle: handle,
                  name: name
                },
                suggestedCountry: suggestedCountry,
                suggestedLanguage: suggestedLanguage
              };
              return _context2.a(2, browsingContext);
          }
        }, _callee2);
      }));
      function getBrowsingContext() {
        return _getBrowsingContext.apply(this, arguments);
      }
      return getBrowsingContext;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/PredictiveSearch/PredictiveSearch.ts":
/*!***************************************************************************!*\
  !*** ./resources/scripts/components/PredictiveSearch/PredictiveSearch.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PredictiveSearch)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var PredictiveSearch = /*#__PURE__*/function (_HTMLElement) {
  function PredictiveSearch() {
    var _this;
    _classCallCheck(this, PredictiveSearch);
    _this = _callSuper(this, PredictiveSearch);
    _defineProperty(_this, "searchInput", null);
    _defineProperty(_this, "predictiveSearchResultsContainer", null);
    _defineProperty(_this, "closeButton", null);
    _defineProperty(_this, "popularSearchTermElements", []);
    _defineProperty(_this, "debounceTimeout", null);
    _defineProperty(_this, "debounceDelay", 300);
    _defineProperty(_this, "pagesSearchEnabled", void 0);
    _defineProperty(_this, "articlesSearchEnabled", void 0);
    _defineProperty(_this, "collectionsSearchEnabled", void 0);
    _defineProperty(_this, "resourceLimit", void 0);
    _defineProperty(_this, "resourceLimitScope", void 0);
    _defineProperty(_this, "unavailableProductsHandling", void 0);
    _defineProperty(_this, "predictiveSearchURL", void 0);
    _defineProperty(_this, "sectionId", void 0);
    _defineProperty(_this, "initialHtml", "");
    _defineProperty(_this, "predictiveSearchComponentToggles", []);
    _defineProperty(_this, "predictiveSearchComponent", null);
    _defineProperty(_this, "resourceOptionsFields", ["author", "body", "product_type", "tag", "title", "variants.barcode", "variants.sku", "variants.title", "vendor"]);
    _this.initDataAndElements = _this.initDataAndElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.handleSearchInput = _this.handleSearchInput.bind(_this);
    return _this;
  }
  _inherits(PredictiveSearch, _HTMLElement);
  return _createClass(PredictiveSearch, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initDataAndElements();
      this.addEventListeners();
    }
  }, {
    key: "initDataAndElements",
    value: function initDataAndElements() {
      this.pagesSearchEnabled = this.dataset.pagesSearchEnabled === "true";
      this.articlesSearchEnabled = this.dataset.articlesSearchEnabled === "true";
      this.collectionsSearchEnabled = this.dataset.collectionsSearchEnabled === "true";
      this.resourceLimit = parseInt(this.dataset.resourceLimit || "5", 10);
      this.resourceLimitScope = this.dataset.resourceLimitScope === "each" ? "each" : "all";
      this.unavailableProductsHandling = ["hide", "show", "last"].includes(this.dataset.unavailableProductsHandling || "") ? this.dataset.unavailableProductsHandling : "show";
      this.predictiveSearchURL = this.dataset.predictiveSearchUrl;
      this.sectionId = this.dataset.sectionId;
      this.searchInput = this.querySelector("input[type='search']");
      this.predictiveSearchResultsContainer = this.querySelector("#edition-predictive-search-results-container");
      this.popularSearchTermElements = Array.from(this.querySelectorAll(".popular-search-term"));
      this.closeButton = this.querySelector("#edition-predictive-search-close-button");
      this.initialHtml = this.predictiveSearchResultsContainer ? this.predictiveSearchResultsContainer.innerHTML : "";
      this.predictiveSearchComponent = this;
      this.predictiveSearchComponentToggles = Array.from(document.querySelectorAll(".search-bar-nav"));
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      // enter key to perform search on /search
      this.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          var target = event.target;
          if (target === _this2.searchInput) {
            var _this2$searchInput;
            event.preventDefault();
            var searchTerm = ((_this2$searchInput = _this2.searchInput) === null || _this2$searchInput === void 0 ? void 0 : _this2$searchInput.value.trim()) || "";
            if (searchTerm.length > 0) {
              window.location.href = "/search?q=".concat(encodeURIComponent(searchTerm));
            }
          }
        }
      });
      // escape key to close search
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          event.preventDefault();
          _this2.toggleSearchInput(false);
        }
      });
      // Click outside to close search
      document.addEventListener("click", function (event) {
        var _this2$predictiveSear;
        var target = event.target;
        var isClickInside = ((_this2$predictiveSear = _this2.predictiveSearchComponent) === null || _this2$predictiveSear === void 0 ? void 0 : _this2$predictiveSear.contains(target)) || false;
        var isToggleButton = _this2.predictiveSearchComponentToggles.some(function (toggle) {
          return toggle.contains(target);
        });
        if (!isClickInside && !isToggleButton) {
          _this2.toggleSearchInput(false);
        }
      });
      this.predictiveSearchComponentToggles.forEach(function (toggle) {
        toggle.addEventListener("click", function (event) {
          var _this2$predictiveSear2;
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          var isVisible = ((_this2$predictiveSear2 = _this2.predictiveSearchComponent) === null || _this2$predictiveSear2 === void 0 ? void 0 : _this2$predictiveSear2.classList.contains("is-visible")) || false;
          _this2.toggleSearchInput(!isVisible);
        });
      });
      if (this.searchInput) {
        this.searchInput.addEventListener("input", this.handleSearchInput);
      }
      this.popularSearchTermElements.forEach(function (element) {
        element.addEventListener("click", function (event) {
          event.preventDefault();
          var searchTerm = element.dataset.term || "";
          if (_this2.searchInput) {
            _this2.searchInput.value = searchTerm;
            _this2.performSearch(searchTerm);
          }
        });
      });
      if (this.closeButton) {
        this.closeButton.addEventListener("click", function (event) {
          event.preventDefault();
          if (_this2.searchInput) {
            _this2.handleClearSearch();
          }
        });
      }
      // handle click inside. Some themes might try to close the search on any click.
      this.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }
  }, {
    key: "handleSearchInput",
    value: function handleSearchInput(event) {
      var _this3 = this;
      var target = event.target;
      var searchTerm = target.value.trim();
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = window.setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(searchTerm.length > 0)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return _this3.performSearch(searchTerm);
            case 1:
              _this3.toggleCloseButton(searchTerm.length > 0);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      })), this.debounceDelay);
    }
  }, {
    key: "toggleCloseButton",
    value: function toggleCloseButton(show) {
      if (this.closeButton) {
        this.closeButton.classList.toggle("is-visible", show);
      }
    }
  }, {
    key: "performSearch",
    value: function () {
      var _performSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(searchTerm) {
        var searchURL, response, text, doc, resultsContainer, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.toggleLoadingOverlay(true);
              searchURL = this.buildSearchURL(searchTerm);
              _context2.p = 1;
              _context2.n = 2;
              return fetch(searchURL);
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 3;
                break;
              }
              throw new Error("Network response was not ok: ".concat(response.statusText));
            case 3:
              _context2.n = 4;
              return response.text();
            case 4:
              text = _context2.v;
              doc = new DOMParser().parseFromString(text, "text/html");
              resultsContainer = doc.querySelector("#edition-predictive-search-results-container");
              if (this.predictiveSearchResultsContainer && resultsContainer) {
                this.predictiveSearchResultsContainer.innerHTML = resultsContainer.innerHTML;
              }
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              console.error("Error performing predictive search:", _t);
            case 6:
              _context2.p = 6;
              this.toggleLoadingOverlay(false);
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5, 6, 7]]);
      }));
      function performSearch(_x) {
        return _performSearch.apply(this, arguments);
      }
      return performSearch;
    }()
  }, {
    key: "buildSearchURL",
    value: function buildSearchURL(searchTerm) {
      var url = new URL(window.location.origin + this.predictiveSearchURL);
      if (searchTerm) {
        url.searchParams.set("q", searchTerm);
      }
      url.searchParams.set("resources[type]", this.getResourceTypes().join(","));
      url.searchParams.set("resources[options][fields]", this.getResourceOptionsFields().join(","));
      url.searchParams.set("resources[limit]", this.resourceLimit.toString());
      url.searchParams.set("resources[limit_scope]", this.resourceLimitScope);
      url.searchParams.set("resources[unavailable_products]", this.unavailableProductsHandling);
      url.searchParams.set("section_id", this.sectionId);
      return url.toString();
    }
  }, {
    key: "getResourceTypes",
    value: function getResourceTypes() {
      var types = ["product"];
      if (this.pagesSearchEnabled) {
        types.push("page");
      }
      if (this.articlesSearchEnabled) {
        types.push("article");
      }
      if (this.collectionsSearchEnabled) {
        types.push("collection");
      }
      return types;
    }
  }, {
    key: "getResourceOptionsFields",
    value: function getResourceOptionsFields() {
      return this.resourceOptionsFields;
    }
  }, {
    key: "toggleLoadingOverlay",
    value: function toggleLoadingOverlay(show) {
      var loadingOverlay = this.querySelector("#edition-predictive-search-loading-overlay");
      if (loadingOverlay) {
        loadingOverlay.classList.toggle("is-active", show);
      }
    }
  }, {
    key: "handleClearSearch",
    value: function handleClearSearch() {
      if (this.searchInput) {
        this.searchInput.value = "";
        if (this.predictiveSearchResultsContainer) {
          this.predictiveSearchResultsContainer.innerHTML = this.initialHtml;
          this.toggleCloseButton(false);
        }
      }
    }
  }, {
    key: "toggleSearchInput",
    value: function toggleSearchInput(show) {
      if (this.predictiveSearchComponent) {
        document.body.classList.toggle("predictive-search-open", show);
        this.predictiveSearchComponent.classList.toggle("is-visible", show);
        // Focus the input when opening
        if (show && this.searchInput) {
          this.searchInput.focus();
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/RemoveAll/RemoveAll.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/RemoveAll/RemoveAll.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ RemoveAll)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var RemoveAll = /*#__PURE__*/function (_HTMLElement) {
  function RemoveAll() {
    var _this;
    _classCallCheck(this, RemoveAll);
    _this = _callSuper(this, RemoveAll);
    _defineProperty(_this, "id", _this.dataset.id);
    _this.handleRemoveAll = _this.handleRemoveAll.bind(_this);
    return _this;
  }
  _inherits(RemoveAll, _HTMLElement);
  return _createClass(RemoveAll, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener("click", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                event.preventDefault();
                _context.n = 1;
                return _this2.handleRemoveAll();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "handleRemoveAll",
    value: function () {
      var _handleRemoveAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  id: this.id,
                  quantity: 0
                })
              });
            case 1:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 2;
                break;
              }
              throw new Error("HTTP error status: ".concat(response.status));
            case 2:
              document.dispatchEvent(new CustomEvent("cart:build"));
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.log("error", _t);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function handleRemoveAll() {
        return _handleRemoveAll.apply(this, arguments);
      }
      return handleRemoveAll;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ShopTheLook/ShopTheLook.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/ShopTheLook/ShopTheLook.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ShopTheLook)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var ShopTheLook = /*#__PURE__*/function (_HTMLElement) {
  function ShopTheLook() {
    var _this;
    _classCallCheck(this, ShopTheLook);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ShopTheLook, [].concat(args));
    _defineProperty(_this, "dots", null);
    _defineProperty(_this, "handlers", new WeakMap());
    return _this;
  }
  _inherits(ShopTheLook, _HTMLElement);
  return _createClass(ShopTheLook, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$dots,
        _this2 = this,
        _this$dots2;
      this.dots = this.querySelectorAll(".stl-dot");
      var container = this.querySelector(".stl-image-wrap");
      var popovers = this.querySelectorAll(".stl-popover");
      (_this$dots = this.dots) === null || _this$dots === void 0 || _this$dots.forEach(function (dot) {
        _this2.clampDotToContainer(dot, container);
        var pop = _this2.getPopover(dot);
        if (pop) _this2.placePopover(pop, container);
      });
      (_this$dots2 = this.dots) === null || _this$dots2 === void 0 || _this$dots2.forEach(function (dot) {
        var enter = function enter(e) {
          return _this2.showDotPopover(e.currentTarget, container);
        };
        var leave = function leave(e) {
          var btn = e.currentTarget;
          var pop = _this2.getPopover(btn);
          var related = e.relatedTarget;
          if (related && (pop !== null && pop !== void 0 && pop.contains(related) || btn.contains(related))) return;
          _this2.hideDotPopover(btn);
        };
        var click = function click(e) {
          var _this2$dots;
          e.preventDefault();
          var btn = e.currentTarget;
          var expanded = btn.getAttribute("aria-expanded") === "true";
          popovers.forEach(function (p) {
            p.style.display = "none";
          });
          (_this2$dots = _this2.dots) === null || _this2$dots === void 0 || _this2$dots.forEach(function (d) {
            return d.setAttribute("aria-expanded", "false");
          });
          if (!expanded) _this2.showDotPopover(btn, container, true);
        };
        _this2.handlers.set(dot, {
          enter: enter,
          leave: leave,
          click: click
        });
        dot.addEventListener("mouseenter", enter);
        dot.addEventListener("mouseleave", leave);
        dot.addEventListener("click", click);
        dot.addEventListener("keydown", function (ev) {
          if (ev.key === "Escape") _this2.hideDotPopover(dot);
          if (ev.key === "Enter" || ev.key === " ") {
            ev.preventDefault();
            dot.click();
          }
        });
      });
      // Click outside to close
      document.addEventListener("click", function (evt) {
        if (!_this2.contains(evt.target)) {
          var _this2$dots2;
          popovers.forEach(function (p) {
            p.style.display = "none";
          });
          (_this2$dots2 = _this2.dots) === null || _this2$dots2 === void 0 || _this2$dots2.forEach(function (d) {
            return d.setAttribute("aria-expanded", "false");
          });
        }
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$dots3,
        _this3 = this;
      (_this$dots3 = this.dots) === null || _this$dots3 === void 0 || _this$dots3.forEach(function (dot) {
        var h = _this3.handlers.get(dot);
        if (!h) return;
        dot.removeEventListener("mouseenter", h.enter);
        dot.removeEventListener("mouseleave", h.leave);
        dot.removeEventListener("click", h.click);
        _this3.handlers["delete"](dot);
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "clampDotToContainer",
    value: function clampDotToContainer(dot, _container) {
      var x = ShopTheLook.num(dot.dataset.dotX, 50);
      var y = ShopTheLook.num(dot.dataset.dotY, 50);
      var clampedX = ShopTheLook.clamp(x, 0, 100);
      var clampedY = ShopTheLook.clamp(y, 0, 100);
      dot.style.left = "".concat(clampedX, "%");
      dot.style.top = "".concat(clampedY, "%");
      dot.dataset.dotX = String(clampedX);
      dot.dataset.dotY = String(clampedY);
      dot.style.translate = "-50% -50%";
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getPopover",
    value: function getPopover(dot) {
      var _wrap$querySelector;
      var wrap = dot.closest(".stl-dot-container");
      return (_wrap$querySelector = wrap === null || wrap === void 0 ? void 0 : wrap.querySelector(".stl-popover")) !== null && _wrap$querySelector !== void 0 ? _wrap$querySelector : null;
    }
  }, {
    key: "showDotPopover",
    value: function showDotPopover(dot, container) {
      var _this4 = this;
      var persist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var pop = this.getPopover(dot);
      if (!pop) return;
      pop.style.display = "block";
      dot.setAttribute("aria-expanded", "true");
      this.placePopover(pop, container);
      if (!persist) {
        var _onLeave = function onLeave(e) {
          var related = e.relatedTarget;
          if (related && (pop.contains(related) || dot.contains(related))) return;
          _this4.hideDotPopover(dot);
          pop.removeEventListener("mouseleave", _onLeave);
        };
        pop.addEventListener("mouseleave", _onLeave);
      }
    }
  }, {
    key: "hideDotPopover",
    value: function hideDotPopover(dot) {
      var pop = this.getPopover(dot);
      if (!pop) return;
      pop.style.display = "none";
      dot.setAttribute("aria-expanded", "false");
    }
  }, {
    key: "placePopover",
    value: function placePopover(pop, container) {
      if (!container) return;
      var cRect = container.getBoundingClientRect();
      var pRect = pop.getBoundingClientRect();
      var pad = 8;
      var leftPercent = this.extractPercent(pop.style.left, 50);
      var topPercent = this.extractPercent(pop.style.top, 50);
      var leftPx = cRect.left + leftPercent / 100 * cRect.width;
      var topPx = cRect.top + topPercent / 100 * cRect.height;
      var currentTranslate = this.parseTranslate(pop.style.translate || "-50% -100%");
      var _currentTranslate = _slicedToArray(currentTranslate, 2),
        tx = _currentTranslate[0],
        ty = _currentTranslate[1];
      var txPx = tx / 100 * pRect.width;
      var tyPx = ty / 100 * pRect.height;
      var boxLeft = leftPx + txPx;
      var boxTop = topPx + tyPx;
      var corrX = 0;
      var corrY = 0;
      if (boxLeft < cRect.left + pad) corrX = cRect.left + pad - boxLeft;
      if (boxLeft + pRect.width > cRect.right - pad) corrX = cRect.right - pad - (boxLeft + pRect.width);
      if (boxTop < cRect.top + pad) corrY = cRect.top + pad - boxTop;
      if (boxTop + pRect.height > cRect.bottom - pad) corrY = cRect.bottom - pad - (boxTop + pRect.height);
      tx += corrX / pRect.width * 100;
      ty += corrY / pRect.height * 100;
      pop.style.translate = "".concat(tx, "% ").concat(ty, "%");
    }
  }, {
    key: "extractPercent",
    value:
    // eslint-disable-next-line class-methods-use-this
    function extractPercent(cssValue) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!cssValue || !cssValue.endsWith("%")) return fallback;
      var n = Number(cssValue.replace("%", ""));
      return Number.isFinite(n) ? n : fallback;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "parseTranslate",
    value: function parseTranslate(translate) {
      var _parts$, _parts$2;
      // expects "<x>% <y>%"
      var parts = translate.split(/\s+/);
      var x = (_parts$ = parts[0]) !== null && _parts$ !== void 0 && _parts$.endsWith("%") ? Number(parts[0].replace("%", "")) : -50;
      var y = (_parts$2 = parts[1]) !== null && _parts$2 !== void 0 && _parts$2.endsWith("%") ? Number(parts[1].replace("%", "")) : -100;
      return [Number.isFinite(x) ? x : -50, Number.isFinite(y) ? y : -100];
    }
  }], [{
    key: "clamp",
    value: function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }
  }, {
    key: "num",
    value: function num(v, fallback) {
      var n = Number(v);
      return Number.isFinite(n) ? n : fallback;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Wishlist/Wishlist.ts":
/*!***********************************************************!*\
  !*** ./resources/scripts/components/Wishlist/Wishlist.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Wishlist)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/* eslint-disable no-empty */
/* eslint-disable class-methods-use-this */
var Wishlist = /*#__PURE__*/function (_HTMLElement) {
  function Wishlist() {
    var _this;
    _classCallCheck(this, Wishlist);
    _this = _callSuper(this, Wishlist);
    _defineProperty(_this, "url", void 0);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.renderWishlistItems = _this.renderWishlistItems.bind(_this);
    _this.generateWishlistItems = _this.generateWishlistItems.bind(_this);
    return _this;
  }
  _inherits(Wishlist, _HTMLElement);
  return _createClass(Wishlist, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.url = this.dataset.url;
              this.addEventListeners();
              // Only render items if this component has a URL (i.e., it's the main wishlist page component)
              if (!this.url) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.renderWishlistItems();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      document.addEventListener("wishlistUpdated", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_event) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return _this2.renderWishlistItems();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "renderWishlistItems",
    value: function () {
      var _renderWishlistItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var currentWishlist, parsedWishlist, wishlistItemsHtml;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              currentWishlist = localStorage.getItem("wishlist");
              parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : []; // clear the content of the wishlist-items element
              this.innerHTML = "";
              if (!(parsedWishlist.length === 0)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return this.generateWishlistItems(parsedWishlist);
            case 2:
              wishlistItemsHtml = _context3.v;
              this.innerHTML = wishlistItemsHtml;
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function renderWishlistItems() {
        return _renderWishlistItems.apply(this, arguments);
      }
      return renderWishlistItems;
    }()
  }, {
    key: "generateWishlistItems",
    value: function () {
      var _generateWishlistItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(parsedWishlist) {
        var _this3 = this;
        var batchSize, batches, idsArray, i, responses, template, wishlitItemsHtml, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              if (this.url) {
                _context4.n = 1;
                break;
              }
              // eslint-disable-next-line no-console
              console.error("Wishlist component: data-url is missing");
              return _context4.a(2, "");
            case 1:
              batchSize = 1;
              batches = [];
              idsArray = parsedWishlist.map(function (id) {
                return "id:".concat(id);
              }); // eslint-disable-next-line no-console
              console.log("ids", idsArray);
              for (i = 0; i < idsArray.length; i += batchSize) {
                batches.push(idsArray.slice(i, i + batchSize).join(" OR "));
              }
              _context4.n = 2;
              return Promise.all(batches.map(function (batchQuery) {
                return fetch("".concat(_this3.url, "&q=").concat(batchQuery)).then(function (res) {
                  if (!res.ok) throw new Error("Network response was not ok: ".concat(res.status));
                  return res.text().then(function (text) {
                    return text;
                  });
                });
              }));
            case 2:
              responses = _context4.v;
              template = document.createElement("template");
              wishlitItemsHtml = responses.map(function (response, _index) {
                template.innerHTML = response;
                var wishlistItemsWrapper = template.content.querySelector("wishlist-component");
                return wishlistItemsWrapper ? Array.from(wishlistItemsWrapper.children).map(function (child) {
                  return child.outerHTML;
                }).join("") : "";
              }).join("");
              return _context4.a(2, wishlitItemsHtml);
            case 3:
              _context4.p = 3;
              _t = _context4.v;
              // eslint-disable-next-line no-console
              console.error("Wishlist generateWishlistItems error:", _t);
              return _context4.a(2, "");
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function generateWishlistItems(_x2) {
        return _generateWishlistItems.apply(this, arguments);
      }
      return generateWishlistItems;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Wishlist/WishlistButton.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/Wishlist/WishlistButton.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ WishlistButton)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var WishlistButton = /*#__PURE__*/function (_HTMLElement) {
  function WishlistButton() {
    var _this;
    _classCallCheck(this, WishlistButton);
    _this = _callSuper(this, WishlistButton);
    _defineProperty(_this, "id", void 0);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.toggleProductInWishlist = _this.toggleProductInWishlist.bind(_this);
    _this.checkIfProductIsInWishlist = _this.checkIfProductIsInWishlist.bind(_this);
    return _this;
  }
  _inherits(WishlistButton, _HTMLElement);
  return _createClass(WishlistButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.id = this.dataset.id;
      this.checkIfProductIsInWishlist();
      this.addEventListeners();
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      this.addEventListener("click", function (event) {
        event.preventDefault();
        _this2.toggleProductInWishlist();
        _this2.animateWishlistButton(event);
      });
    }
  }, {
    key: "toggleProductInWishlist",
    value: function toggleProductInWishlist() {
      var _this3 = this;
      var wishlist = localStorage.getItem("wishlist");
      var parsedWishlist = wishlist ? JSON.parse(wishlist) : [];
      // Wishlist is an array of handles
      var productIndex = parsedWishlist.findIndex(function (item) {
        return item === _this3.id;
      });
      if (productIndex !== -1) {
        parsedWishlist.splice(productIndex, 1); // Remove product
      } else {
        parsedWishlist.push(this.id); // Add product
      }
      localStorage.setItem("wishlist", JSON.stringify(parsedWishlist));
      this.classList.toggle("added-to-wishlist");
      // Dispatch event to update wishlist count
      var wishlistUpdatedEvent = new CustomEvent("wishlistUpdated", {
        detail: {
          wishlistCount: parsedWishlist.length,
          rerender: true
        }
      });
      document.dispatchEvent(wishlistUpdatedEvent);
    }
  }, {
    key: "checkIfProductIsInWishlist",
    value: function checkIfProductIsInWishlist() {
      var wishlist = localStorage.getItem("wishlist");
      if (wishlist) {
        var parsedWishlist = JSON.parse(wishlist);
        if (parsedWishlist.includes(this.id)) {
          this.classList.add("added-to-wishlist");
        }
      }
    }
  }, {
    key: "animateWishlistButton",
    value: function animateWishlistButton(event) {
      var particleWrapper = this.querySelector(".particles-wrapper");
      if (!particleWrapper) return;
      // Get the correct coordinates based on the event type
      var clientX;
      var clientY;
      if (event instanceof MouseEvent) {
        clientX = event.clientX;
        clientY = event.clientY;
      } else if (event instanceof TouchEvent) {
        clientX = event.touches[0].clientX;
        clientY = event.touches[0].clientY;
      } else {
        return;
      }
      // Calculate position relative to particleWrapper
      var rect = particleWrapper.getBoundingClientRect();
      var offsetX = clientX - rect.left;
      var offsetY = clientY - rect.top;
      var _loop = function _loop() {
        var particle = document.createElement("div");
        particle.classList.add("particles");
        // Randomize movement direction
        var angle = Math.random() * 2 * Math.PI;
        var distance = Math.random() * 20 + 10; // Spread particles outwards
        var x = Math.cos(angle) * distance;
        var y = Math.sin(angle) * distance;
        // Position relative to click/touch
        particle.style.left = "".concat(offsetX, "px");
        particle.style.top = "".concat(offsetY, "px");
        particle.style.setProperty("--x", "".concat(x, "px"));
        particle.style.setProperty("--y", "".concat(y, "px"));
        particleWrapper.appendChild(particle);
        // Remove particle after animation (matching duration in CSS)
        setTimeout(function () {
          return particle.remove();
        }, 2000);
      };
      for (var i = 0; i < 15; i += 1) {
        _loop();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/lowStock/lowStock.ts":
/*!***********************************************************!*\
  !*** ./resources/scripts/components/lowStock/lowStock.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ LowStock)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var LowStock = /*#__PURE__*/function (_HTMLElement) {
  function LowStock() {
    var _this;
    _classCallCheck(this, LowStock);
    _this = _callSuper(this, LowStock);
    _defineProperty(_this, "productUrl", _this.dataset.producturl);
    _defineProperty(_this, "url", _this.dataset.url);
    _defineProperty(_this, "eventListenersAdded", _this.dataset.eventlistenersAdded === "true");
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.handleComponentUpdate = _this.handleComponentUpdate.bind(_this);
    return _this;
  }
  _inherits(LowStock, _HTMLElement);
  return _createClass(LowStock, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListeners();
      console.log("InventoryDeliveryComponent connected");
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _window,
        _window$lowStockVaria,
        _this2 = this;
      (_window$lowStockVaria = (_window = window).lowStockVariantListenerAdded) !== null && _window$lowStockVaria !== void 0 ? _window$lowStockVaria : _window.lowStockVariantListenerAdded = false;
      if (window.lowStockVariantListenerAdded) {
        this.eventListenersAdded = true;
        return;
      }
      if (!this.eventListenersAdded) {
        document.addEventListener("variant:change", function (event) {
          var variantId = event.detail.variant.id;
          _this2.handleComponentUpdate(variantId);
        });
        window.lowStockVariantListenerAdded = true;
        this.eventListenersAdded = true;
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      console.log("InventoryDeliveryComponent disconnected");
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleComponentUpdate",
    value: function () {
      var _handleComponentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(variantId) {
        var baseUrl, response, error, data, freshComponent, currentComponent, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              baseUrl = "".concat(this.url).concat(this.productUrl, "?variant=").concat(variantId);
              console.log("LowStock component updating", baseUrl);
              _context.p = 1;
              _context.n = 2;
              return fetch("".concat(baseUrl, "?section_id=main-product"));
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              error = new Error("HTTP error! status: ".concat(response.status));
              throw error;
            case 3:
              _context.n = 4;
              return response.text();
            case 4:
              data = _context.v;
              freshComponent = new DOMParser().parseFromString(data, "text/html").querySelector("low-stock");
              if (freshComponent) {
                currentComponent = document.querySelector("low-stock");
                if (currentComponent !== freshComponent && currentComponent.parentNode) {
                  // Use parentNode.replaceChild for better iOS Safari compatibility
                  currentComponent.parentNode.replaceChild(freshComponent, currentComponent);
                }
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error("Error fetching product page", _t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 5]]);
      }));
      function handleComponentUpdate(_x) {
        return _handleComponentUpdate.apply(this, arguments);
      }
      return handleComponentUpdate;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/CookieMethods.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deleteCookie": () => (/* binding */ deleteCookie),
/* harmony export */   "getCookie": () => (/* binding */ getCookie),
/* harmony export */   "setCookie": () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ }),

/***/ "./resources/scripts/utils/Logger.ts":
/*!*******************************************!*\
  !*** ./resources/scripts/utils/Logger.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Structured Logger Utility
 * Logs structured objects with timestamps, levels, and metadata
 *
 * @example
 * import log from '@utils/Logger';
 *
 * log.info('User logged in', { userId: 123 });
 * log.success('Payment processed', { amount: 99.99 });
 * log.warn('Cart is empty');
 * log.error('API request failed', { endpoint: '/api/cart' });
 */
var styles = {
  INFO: "color: #3B82F6; font-weight: bold;",
  SUCCESS: "color: #10B981; font-weight: bold;",
  WARN: "color: #F59E0B; font-weight: bold;",
  ERROR: "color: #EF4444; font-weight: bold;"
};
var createLogEntry = function createLogEntry(level, message, additionalData) {
  var includeStack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var timestamp = new Date().toISOString();
  // Handle different message types
  var logMessage;
  var logData = additionalData;
  if (typeof message === "string") {
    logMessage = message;
  } else if (_typeof(message) === "object" && message !== null) {
    logMessage = "Object logged";
    logData = message;
  } else {
    logMessage = String(message);
  }
  var entry = {
    timestamp: timestamp,
    level: level,
    message: logMessage
  };
  if (logData !== undefined) {
    entry.data = logData;
  }
  // Add stack trace for errors or when explicitly requested
  if (includeStack) {
    var _Error = new Error(),
      stack = _Error.stack;
    if (stack) {
      // Remove the first 3 lines (Error message and logger internals)
      entry.stack = stack.split("\n").slice(3).join("\n");
    }
  }
  // Add context information
  if (typeof window !== "undefined") {
    entry.context = {
      url: window.location.href,
      userAgent: navigator.userAgent,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };
  }
  return entry;
};
var logWithStyle = function logWithStyle(consoleMethod, level, entry) {
  console[consoleMethod]("%c[".concat(level, "]"), styles[level], entry);
};
var logger = {
  info: function info(message, data) {
    var entry = createLogEntry("INFO", message, data);
    logWithStyle("log", "INFO", entry);
  },
  success: function success(message, data) {
    var entry = createLogEntry("SUCCESS", message, data);
    logWithStyle("log", "SUCCESS", entry);
  },
  warn: function warn(message, data) {
    var entry = createLogEntry("WARN", message, data, true);
    logWithStyle("warn", "WARN", entry);
  },
  error: function error(message, data) {
    var entry = createLogEntry("ERROR", message, data, true);
    logWithStyle("error", "ERROR", entry);
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (logger);

/***/ }),

/***/ "./resources/scripts/utils/Storage.ts":
/*!********************************************!*\
  !*** ./resources/scripts/utils/Storage.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NamespacedStorage": () => (/* binding */ NamespacedStorage),
/* harmony export */   "StorageHelper": () => (/* binding */ StorageHelper),
/* harmony export */   "local": () => (/* binding */ local),
/* harmony export */   "session": () => (/* binding */ session)
/* harmony export */ });
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Logger */ "./resources/scripts/utils/Logger.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/* eslint-disable max-classes-per-file, no-plusplus, @typescript-eslint/no-use-before-define */
/**
 * Type-safe LocalStorage and SessionStorage Utility
 * Handles JSON parsing, expiration, and error handling
 *
 * @example
 * import { local, session } from '@utils/Storage';
 *
 * // Basic usage LocalStorage
 * local.set('user', { id: 123, name: 'John' });
 * const user = local.get('user'); // Returns parsed object or null
 *
 * // With expiration (in minutes)
 * local.set('token', 'abc123', 60); // Expires in 60 minutes
 *
 * // Basic usage SessionStorage
 * session.set('sessionId', 'xyz789');
 * const sessionId = session.get('sessionId'); // Returns 'xyz789' or null
 *
 * // Advanced usage with namespaces
 * const cartStorage = local.namespace('cart');
 * cartStorage.set('items', [{ id: 1, qty: 2 }]);
 * const items = cartStorage.get('items'); // Returns array or null
 */

var StorageHelper = /*#__PURE__*/function () {
  function StorageHelper(type) {
    _classCallCheck(this, StorageHelper);
    _defineProperty(this, "storage", null);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "isAvailable", false);
    this.type = type;
    this.checkAvailability();
  }
  /**
   * Check if storage is available (handles private browsing, etc.)
   */
  return _createClass(StorageHelper, [{
    key: "checkAvailability",
    value: function checkAvailability() {
      try {
        var storage = window[this.type];
        var testKey = "__storage_test__";
        storage.setItem(testKey, "test");
        storage.removeItem(testKey);
        this.storage = storage;
        this.isAvailable = true;
      } catch (e) {
        this.isAvailable = false;
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].warn("".concat(this.type, " is not available"), {
          error: e
        });
      }
    }
    /**
     * Set an item in storage
     */
  }, {
    key: "set",
    value: function set(key, value, expiresInMinutes) {
      if (!this.isAvailable || !this.storage) return false;
      try {
        var item = {
          value: value
        };
        if (expiresInMinutes) {
          item.expires = Date.now() + expiresInMinutes * 60 * 1000;
        }
        this.storage.setItem(key, JSON.stringify(item));
        return true;
      } catch (e) {
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("Failed to set storage item", {
          key: key,
          error: e
        });
        return false;
      }
    }
    /**
     * Get an item from storage
     */
  }, {
    key: "get",
    value: function get(key) {
      if (!this.isAvailable || !this.storage) return null;
      try {
        var raw = this.storage.getItem(key);
        if (!raw) return null;
        var item = JSON.parse(raw);
        // Check expiration
        if (item.expires && Date.now() > item.expires) {
          this.remove(key);
          return null;
        }
        return item.value;
      } catch (e) {
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("Failed to get storage item", {
          key: key,
          error: e
        });
        return null;
      }
    }
    /**
     * Remove an item from storage
     */
  }, {
    key: "remove",
    value: function remove(key) {
      if (!this.isAvailable || !this.storage) return false;
      try {
        this.storage.removeItem(key);
        return true;
      } catch (e) {
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("Failed to remove storage item", {
          key: key,
          error: e
        });
        return false;
      }
    }
    /**
     * Clear all items from storage
     */
  }, {
    key: "clear",
    value: function clear() {
      if (!this.isAvailable || !this.storage) return false;
      try {
        this.storage.clear();
        return true;
      } catch (e) {
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("Failed to clear storage", {
          error: e
        });
        return false;
      }
    }
    /**
     * Check if a key exists in storage
     */
  }, {
    key: "has",
    value: function has(key) {
      if (!this.isAvailable || !this.storage) return false;
      return this.storage.getItem(key) !== null;
    }
    /**
     * Get all keys in storage
     */
  }, {
    key: "keys",
    value: function keys() {
      if (!this.isAvailable || !this.storage) return [];
      var keys = [];
      for (var i = 0; i < this.storage.length; i++) {
        var key = this.storage.key(i);
        if (key) keys.push(key);
      }
      return keys;
    }
    /**
     * Get storage size in bytes (approximate)
     */
  }, {
    key: "size",
    value: function size() {
      if (!this.isAvailable || !this.storage) return 0;
      var total = 0;
      for (var i = 0; i < this.storage.length; i++) {
        var key = this.storage.key(i);
        if (key) {
          var value = this.storage.getItem(key);
          if (value) {
            total += key.length + value.length;
          }
        }
      }
      return total;
    }
    /**
     * Create a namespaced storage helper
     * Prefixes all keys with the namespace
     */
  }, {
    key: "namespace",
    value: function namespace(prefix) {
      return new NamespacedStorage(this, prefix);
    }
    /**
     * Check if storage is available
     */
  }, {
    key: "available",
    get: function get() {
      return this.isAvailable;
    }
  }]);
}();
/**
 * Namespaced storage helper
 * Automatically prefixes all keys with a namespace
 */
var NamespacedStorage = /*#__PURE__*/function () {
  function NamespacedStorage(storage, prefix) {
    _classCallCheck(this, NamespacedStorage);
    _defineProperty(this, "storage", void 0);
    _defineProperty(this, "prefix", void 0);
    this.storage = storage;
    this.prefix = prefix;
  }
  return _createClass(NamespacedStorage, [{
    key: "getKey",
    value: function getKey(key) {
      return "".concat(this.prefix, ":").concat(key);
    }
  }, {
    key: "set",
    value: function set(key, value, expiresInMinutes) {
      return this.storage.set(this.getKey(key), value, expiresInMinutes);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.storage.get(this.getKey(key));
    }
  }, {
    key: "remove",
    value: function remove(key) {
      return this.storage.remove(this.getKey(key));
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.storage.has(this.getKey(key));
    }
    /**
     * Clear all items in this namespace
     */
  }, {
    key: "clear",
    value: function clear() {
      var _this = this;
      var keys = this.storage.keys().filter(function (key) {
        return key.startsWith("".concat(_this.prefix, ":"));
      });
      var success = true;
      keys.forEach(function (key) {
        if (!_this.storage.remove(key)) {
          success = false;
        }
      });
      return success;
    }
    /**
     * Get all keys in this namespace (without prefix)
     */
  }, {
    key: "keys",
    value: function keys() {
      var _this2 = this;
      var prefixLength = this.prefix.length + 1;
      return this.storage.keys().filter(function (key) {
        return key.startsWith("".concat(_this2.prefix, ":"));
      }).map(function (key) {
        return key.substring(prefixLength);
      });
    }
  }]);
}(); // Export singleton instances
var local = new StorageHelper("localStorage");
var session = new StorageHelper("sessionStorage");
// Export classes for advanced usage


/***/ }),

/***/ "./resources/scripts/utils/ThemeScripts.ts":
/*!*************************************************!*\
  !*** ./resources/scripts/utils/ThemeScripts.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ThemeScripts": () => (/* binding */ ThemeScripts)
/* harmony export */ });
/* harmony import */ var _Storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Storage */ "./resources/scripts/utils/Storage.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var CONSENT_STORAGE_KEY = "cookieSelections";
var isConsentGranted = function isConsentGranted() {
  var selections = _Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY);
  return (selections === null || selections === void 0 ? void 0 : selections.analytics) === true;
};
var idleInject = function idleInject(inject) {
  if ("requestIdleCallback" in window) {
    requestIdleCallback(inject);
  } else {
    setTimeout(inject, 0);
  }
};
var buildGtmSrc = function buildGtmSrc(_ref) {
  var containerId = _ref.containerId,
    serverUrl = _ref.serverUrl,
    scriptName = _ref.scriptName;
  if (serverUrl && scriptName) {
    var encodedId = btoa("id=".concat(containerId)).replace(/=+$/, "");
    return "".concat(serverUrl, "/").concat(scriptName, "?P=").concat(encodedId, "&page=1");
  }
  return "https://www.googletagmanager.com/gtm.js?id=".concat(containerId);
};
// ─── Class ────────────────────────────────────────────────────────────────────
/**
 * Third-party script loader with consent-aware loading strategies.
 * GTM is a first-class citizen — pass `id: 'gtm'` and `gtmConfig` and everything
 * else (URL building, `gtm.start` push, noscript fallback) is handled internally.
 *
 * All consent-based strategies defer injection to `requestIdleCallback` once the
 * consent condition is met, so they never block the critical rendering path.
 *
 * @example GTM — client-side
 * ```ts
 * scripts.load({
 *   id: 'gtm',
 *   strategy: 'on-default-consent-set',
 *   gtmConfig: { containerId: 'GTM-XXXXXX' },
 * });
 * ```
 *
 * @example GTM — server-side via stape
 * ```ts
 * scripts.load({
 *   id: 'gtm',
 *   strategy: 'on-default-consent-set',
 *   gtmConfig: { containerId: 'GTM-XXXXXX', serverUrl: 'https://xyz.stape.net', scriptName: 'loader.js' },
 * });
 * ```
 *
 * @example Klaviyo onsite — Loads idlely to avoid blocking
 * ```ts
 * scripts.load({
 *   id: 'klaviyo',
 *   strategy: 'idle',
 *   src: 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XXXXXX',
 * });
 * ```
 *
 * @example Non-critical widget deferred to browser idle time
 * ```ts
 * scripts.load({
 *   id: 'my-widget',
 *   strategy: 'idle',
 *   src: 'https://cdn.example.com/widget.js',
 * });
 * ```
 */
var ThemeScripts = /*#__PURE__*/_createClass(function ThemeScripts() {
  var _this = this;
  _classCallCheck(this, ThemeScripts);
  /** Loads a script according to its strategy. TypeScript narrows to `GtmScriptConfig` when `id: 'gtm'`. */
  _defineProperty(this, "load", function (config) {
    if (config.id === "gtm") {
      _this.loadGtm(config);
      return;
    }
    var id = config.id,
      strategy = config.strategy,
      src = config.src,
      inline = config.inline,
      _config$async = config.async,
      isAsync = _config$async === void 0 ? true : _config$async,
      _config$defer = config.defer,
      defer = _config$defer === void 0 ? false : _config$defer,
      _config$attributes = config.attributes,
      attributes = _config$attributes === void 0 ? {} : _config$attributes,
      onLoad = config.onLoad,
      onError = config.onError;
    _this.applyStrategy({
      strategy: strategy,
      inject: function inject() {
        return _this.inject({
          id: id,
          src: src,
          inline: inline,
          isAsync: isAsync,
          defer: defer,
          attributes: attributes,
          onLoad: onLoad,
          onError: onError
        });
      }
    });
  });
  /** Handles GTM-specific setup: dataLayer push, URL building, noscript fallback. */
  _defineProperty(this, "loadGtm", function (config) {
    var containerId = config.gtmConfig.containerId;
    _this.applyStrategy({
      strategy: config.strategy,
      inject: function inject() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js"
        });
        _this.inject({
          id: "gtm",
          src: buildGtmSrc(config.gtmConfig),
          isAsync: true,
          defer: false,
          attributes: {
            "data-gtm": containerId
          },
          onLoad: config.onLoad,
          onError: config.onError
        });
        if (!document.querySelector("noscript[data-gtm=\"".concat(containerId, "\"]"))) {
          var noscript = document.createElement("noscript");
          noscript.dataset.gtm = containerId;
          var iframe = document.createElement("iframe");
          iframe.src = "https://www.googletagmanager.com/ns.html?id=".concat(containerId);
          iframe.height = "0";
          iframe.width = "0";
          iframe.style.cssText = "display:none;visibility:hidden";
          noscript.appendChild(iframe);
          document.body.insertAdjacentElement("afterbegin", noscript);
        }
      }
    });
  });
  // eslint-disable-next-line class-methods-use-this
  _defineProperty(this, "applyStrategy", function (_ref2) {
    var strategy = _ref2.strategy,
      inject = _ref2.inject;
    switch (strategy) {
      case "immediate":
        {
          inject();
          break;
        }
      case "on-default-consent-set":
        {
          window.addEventListener("edition:consent-default-set", function () {
            return idleInject(inject);
          }, {
            once: true
          });
          break;
        }
      case "on-consent-granted":
        {
          window.addEventListener("edition:consent-default-set", function () {
            if (isConsentGranted()) {
              idleInject(inject);
              return;
            }
            var _waitForConsent = function waitForConsent() {
              if (!isConsentGranted()) return;
              idleInject(inject);
              window.removeEventListener("edition:consent-updated", _waitForConsent);
            };
            window.addEventListener("edition:consent-updated", _waitForConsent);
          }, {
            once: true
          });
          break;
        }
      case "idle":
        {
          idleInject(inject);
          break;
        }
      default:
        {
          var exhaustiveCheck = strategy;
          console.warn("[ThemeScripts] Unknown strategy:", exhaustiveCheck);
        }
    }
  });
  // eslint-disable-next-line class-methods-use-this
  _defineProperty(this, "inject", function (_ref3) {
    var id = _ref3.id,
      src = _ref3.src,
      inline = _ref3.inline,
      isAsync = _ref3.isAsync,
      defer = _ref3.defer,
      attributes = _ref3.attributes,
      onLoad = _ref3.onLoad,
      onError = _ref3.onError;
    if (document.querySelector("script[data-script-id=\"".concat(id, "\"]"))) {
      return;
    }
    if (inline) {
      inline();
    }
    if (!src) {
      return;
    }
    var script = document.createElement("script");
    script.async = isAsync;
    script.defer = defer;
    script.src = src;
    script.dataset.scriptId = id;
    Object.entries(attributes).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];
      script.setAttribute(key, value);
    });
    if (onLoad) {
      script.addEventListener("load", onLoad);
    }
    if (onError) {
      script.addEventListener("error", onError);
    }
    document.head.appendChild(script);
  });
});

/***/ }),

/***/ "./resources/scripts/utils/datalayer/dataLayerLogger.ts":
/*!**************************************************************!*\
  !*** ./resources/scripts/utils/datalayer/dataLayerLogger.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "debugLog": () => (/* binding */ debugLog)
/* harmony export */ });
var LOG_STYLES = {
  header: "background:#4f46e5;color:#fff;padding:2px 8px;border-radius:3px;font-weight:bold",
  event: "background:#10b981;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  context: "background:#0ea5e9;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  consent: "background:#8b5cf6;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  init: "background:#f59e0b;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  config: "background:#6b7280;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  label: "color:inherit;font-weight:bold;margin-left:4px",
  muted: "color:#6b7280;font-style:italic;margin-left:4px"
};
var CATEGORY_LABELS = {
  event: "Event",
  context: "Context",
  consent: "Consent",
  init: "Init",
  config: "Config"
};
var debugLog = function debugLog(_ref) {
  var category = _ref.category,
    label = _ref.label,
    payload = _ref.payload;
  var timestamp = new Date().toISOString();
  var displayTime = timestamp.split("T")[1].replace("Z", "");
  var categoryStyle = LOG_STYLES[category];
  console.groupCollapsed("%cEdition DataLayer%c%s%c%s%c%s", LOG_STYLES.header, categoryStyle, " ".concat(CATEGORY_LABELS[category]), LOG_STYLES.label, " ".concat(label), LOG_STYLES.muted, " ".concat(displayTime));
  if (payload !== undefined) console.log(payload);
  console.groupEnd();
};

/***/ }),

/***/ "./resources/scripts/utils/datalayer/normalizeShopifyId.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/utils/datalayer/normalizeShopifyId.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "normalizeShopifyId": () => (/* binding */ normalizeShopifyId)
/* harmony export */ });
/* eslint-disable import/prefer-default-export */
/**
 * Strips a Shopify GraphQL GID prefix — "gid://shopify/ProductVariant/41327143649342" → "41327143649342".
 * No-op on plain numeric IDs, so it is safe to apply defensively on every ID field.
 * Mirrors the normalization used in the checkout custom pixel.
 */
var normalizeShopifyId = function normalizeShopifyId(id) {
  return String(id).split("/").pop();
};

/***/ }),

/***/ "./resources/scripts/utils/datalayer/toAbsoluteUrl.ts":
/*!************************************************************!*\
  !*** ./resources/scripts/utils/datalayer/toAbsoluteUrl.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "toAbsoluteUrl": () => (/* binding */ toAbsoluteUrl)
/* harmony export */ });
/* eslint-disable import/prefer-default-export */
/** Resolves protocol-relative (`//`) and root-relative (`/`) URLs to fully qualified `https://` URLs. */
var toAbsoluteUrl = function toAbsoluteUrl(url) {
  if (!url) {
    return null;
  }
  if (url.startsWith("//")) {
    return "https:".concat(url);
  }
  if (url.startsWith("/")) {
    return "".concat(window.location.origin).concat(url);
  }
  return url;
};

/***/ }),

/***/ "./resources/scripts/utils/sha256.ts":
/*!*******************************************!*\
  !*** ./resources/scripts/utils/sha256.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sha256": () => (/* binding */ sha256)
/* harmony export */ });
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable import/prefer-default-export */
/** Hashes a string with SHA-256 using the Web Crypto API. Returns null if the value is empty or hashing fails. */
var sha256 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
    var encoded, hashBuffer, hashArray, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (value) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          _context.p = 1;
          encoded = new TextEncoder().encode(value);
          _context.n = 2;
          return crypto.subtle.digest("SHA-256", encoded);
        case 2:
          hashBuffer = _context.v;
          hashArray = Array.from(new Uint8Array(hashBuffer));
          return _context.a(2, hashArray.map(function (b) {
            return b.toString(16).padStart(2, "0");
          }).join(""));
        case 3:
          _context.p = 3;
          _t = _context.v;
          return _context.a(2, null);
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function sha256(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkpitayagermany"] = self["webpackChunkpitayagermany"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;